import { FLAG } from '../../feature-flags';
import { createExperimentExposureTracker } from '../experiment/analytics.js';
import { normalizeExperimentVariant, resolveCalendarExperimentVariant } from '../experiment/analytics.js';
import { adoptEffectiveRut, clearAuraReferralPayload, createAuraReferralForm, createAuraReferralFormWithRut } from '../aura-referral-prefill.js';
import { pageviewContext } from '../analytics/pageview-context.js';

const SPINNER_MIN_MS = 350;

export default ({ building, activeSlug, isWhatsappCta, whatsappUrl, epcWhatsappFromTwo, codePhones, orientations, buildingBadges, globalSuperPromo, quotationPreviewUrl, subscriptionUrl, scheduleSubscriptionUrl }) => {
    const referral = globalThis.__auraReferralPayload ?? {};
    const search = String(globalThis.location?.search ?? '');
    const hasIncomingSignatureHash = typeof URLSearchParams === 'function'
        ? new URLSearchParams(search).has('signatureHash')
        : /(?:^|[?&])signatureHash(?:=|&|$)/.test(search);
    const referralForm = createAuraReferralForm(referral);
    const createContactmeForm = (currentForm = {}) => ({
        ...createAuraReferralForm(referral),
        reason: '',
        refer_code: currentForm.refer_code ?? referral.refer_code ?? '',
        utm_source: currentForm.utm_source ?? '',
        utm_medium: currentForm.utm_medium ?? '',
        utm_campaign: currentForm.utm_campaign ?? '',
        utm_content: currentForm.utm_content ?? '',
        utm_term: currentForm.utm_term ?? '',
        fbclid: currentForm.fbclid ?? '',
        gclid: currentForm.gclid ?? '',
        terms: false,
    });

    return {
    building: building,
    buildingBadges: buildingBadges ?? [],
    globalSuperPromo: globalSuperPromo,
    tabs: building.available_typologies_tabs,
    allGroupedUnits: {},
    originalGroupedUnits: JSON.parse(JSON.stringify(building.units_grouped ?? {})), // Copia profunda de unidades agrupadas
    activeTab: activeSlug,
    currentGroups: {},
    units: building.units,
    currentModels: {},
    processedModels: [], // Nuevo: modelos con información procesada
    typologyOrder: [
        'estudio',
        '1-dormitorio',
        '2-dormitorios',
        '3-dormitorios',
        '4-o-mas-dormitorios',
    ], 
    labels: {
        'estudio': 'estudio',
        '1-dormitorio': '1 dormitorio',
        '2-dormitorios': '2 dormitorios',
        '3-dormitorios': '3 dormitorios',
        '4-o-mas-dormitorios': '4+ dormitorios',
    },
    openDrawerUnits: false,
    openDrawerMultifamily: false,
    openDrawerAvailable: false,
    openDrawerUnitNotFound: false,
    notFoundUnitData: null, // Datos para el drawer de unidad no encontrada
    selectedUnit: null,
    selectedModel: null,
    bottomHeight: 0,  
    sheetExpanded: false, // bottom sheet del calendario en mobile (colapsado por defecto)
    orientationsMap: orientations,
    step: 'list',
    history: [],
    openModalGallery: false,
    tabSelectedGallery: 'fotos',
    isLoadingUnits: false, // Loading logic for units drawer
    isLoadingModels: false, // Loading logic for OD models
    isLoadingUnitDetail: false, // Nueva propiedad para skeleton de detalle
    isNavigating: false, // Nueva propiedad para indicar navegación en progreso
    navigationDirection: 'forward', // Nueva propiedad para la dirección de navegación
    showModalShare: false,
    copyDone: false,
    tabSelected:'fotos',
    // Quote logic
    quote: null,
    quotationPreviewUrl,
    subscriptionUrl,
    scheduleSubscriptionUrl,
    isLoadingQuote: false,
    quoteParams: {
        unit_id: null,
        want_parking: false,
        want_store: false,
        want_pet: false,
        dicom_amount: 2,
        start_date: (() => {
            const today = new Date();
            const nextMonth = new Date(today.getFullYear(), today.getMonth() + 1, 1);
            return nextMonth.toISOString().slice(0, 10);
        })(),
        warranty_type: 1
    },
    // Filtros aplicados desde la URL
    appliedFilters: {
        bedrooms: [],
        bathrooms: [],
        min_price: null,
        max_price: null
    },

    //Notify me
    email: '',
    errorMessage:'',
    loading_notify:false,
    toast: {
        show: false,
        message: '',
        type: 'success',
    },
    notified:false,
    modelNoAvailable: null,
    email_model_no_available: '',
    errorMessageNoAvailable:'',
    isWhatsappCta: isWhatsappCta,
    whatsappUrl: whatsappUrl,
    epcWhatsappFromTwo: epcWhatsappFromTwo,
    // A/B test: variante del botón QQMC. Empieza en CONTROL hasta que PostHog confirme.
    ctaBotonQqmcVariant: FLAG.AB_TEST_BOTON_QQMC.CONTROL,
    // A/B test: variante del flujo de agenda. Empieza en CONTROL hasta que PostHog confirme.
    calendarExperimentVariant: FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA.CONTROL,
    // Asignación real del experimento de agenda: 'control' | 'horario-visible' si el usuario participa,
    // null si no participa (PostHog devolvió false, no respondió a tiempo o el valor no es válido).
    // calendarExperimentVariant decide la UI (sin asignación renderiza CONTROL); este valor es el que
    // se persiste en el lead y el que se usa para el exposure.
    calendarExperimentAssignment: null,
    // Bandera de deduplicación para visit_scheduling:experiment_exposure — una vez que disparamos, no volver a disparar.
    _experimentExposureFired: false,
    // Bandera de deduplicación para $feature_flag_called nativo de PostHog — una vez por sesión cuando la tipología es elegible.
    _calendarNativeExposureFired: false,
    // Bandera para evitar doble registro de listeners en addEventListener
    // cuando init() de Alpine se ejecuta más de una vez (re-mount / hot-reload).
    _experimentListenersAttached: false,
    // Bandera de readiness: indica que calendarExperimentVariant fue resuelto por PostHog.
    experimentVariantResolved: false,
    showContactMeModal: false,
    formDataContactme: createContactmeForm(),
    errors: {
        name: '',
        last_name: '',
        rut: '',
        email: '',
        phone: '',
        terms: '',
        reason: '',
    },
    sendingContactForm: false,

    // ============================================================
    // Visitor form — pasos visitor_form / schedule_* del drawer
    // ============================================================
    form: {
        ...referralForm,
        terms: false,
        movingTimeline: null,
    },
    effectiveRut: referralForm.rut,
    // Estado + lógica del date-picker / time-slots (selectedDate, selectedTime, timeFilter,
    // dpDays(), filteredTimeSlots(), fetchAvailableTimeSlots(), loadMoreDays(), reloadTimeSlots()...).
    // timeSlotsMixin() se define en partials/time-slots-mixin-script.blade.php, incluido en building.blade.php.
    ...(globalThis.timeSlotsMixin?.() ?? {}),
    // Segunda instancia aislada para el calendario interno del schedule_visit.
    // Estado independiente del calendario externo: selectedDate, selectedTime, _availableByDate, etc.
    scheduleVisitCalendar: globalThis.timeSlotsMixin?.() ?? {},
    profileForm: {
        movingTimeline: null,
        hasIncome:    null,
    },
    // V2 booking intent key. has_guarantor is intentionally hardcoded to 1 here;
    // this component has no mutable guarantor state to invalidate.
    bookingIdempotencyKey: null,
    get bookingKey() {
        if (!this.bookingIdempotencyKey) {
            this.bookingIdempotencyKey = globalThis.crypto.randomUUID();
        }
        return this.bookingIdempotencyKey;
    },
    visitorFormMode: 'schedule', // 'schedule' | 'interest'
    get isAuraReferral() {
        return referral.referral_eligible === true && !!referral.signatureHash;
    },
    showMovingTimeline: true,
    similarBuildings: [],
    similarBuildingsIndex: 0,
    _sbTransition: true,
    reqOpen: false,
    sending: false,
    leadId: null, // ID del lead creado en submitVisitorForm, necesario para schedule
    brokerId: null,
    scheduleUrl: null,
    scheduleUrlV1: null,
    codePhones: codePhones,
    hasBroker: false,
    loading_form_contactme: false,
    confirmingSlot: false,
    showInlineCalendar: false,
    mobileAgendaSheetOpen: false,
    mobileAgendaAutoOpened: false,
    // isMobile: indica si el viewport actual es mobile. Se actualiza reactivamente
    // en el breakpoint listener para que Alpine re-evalúe x-show que dependen
    // de window.matchMedia (no es tracking automático en expresiones).
    isMobile: window.matchMedia('(max-width: 1023px)').matches,
    _calendarSlotsPromise: null,
    // Contador de cargas del paso 1 (horario primero): una respuesta tardía de otra unidad se descarta.
    // Número y no objeto: Alpine envuelve objetos en proxies reactivos y rompería la comparación.
    _slotFirstRequestId: 0,

    /**
     * Helper centralizado para asegurar exposure del experimento de agenda.
     *
     * Responsabilidades:
     * 1. Verificar que la variante esté resuelta y PostHog esté listo.
     * 2. Determinar elegibilidad según contexto (Multifamily: typologyIsVisitable).
     * 3. Si es elegible y native exposure aún no se disparó → getVariant(send_event:true)
     *    genera $feature_flag_called de forma idempotente (SDK dedupea por flag+variant).
     * 4. Si es elegible y custom exposure aún no se disparó → trackExperimentExposureIfEligible.
     *
     * Para Unit page (superficies que no son building MF) se usa trackExperimentExposureIfEligible
     * directamente con unit.is_visitable como criterio.
     *
     * @param {object} options
     * @param {boolean} options.isMultifamily - si true, usa typologyIsVisitable como criterio de elegibilidad
     */
    ensureCalendarExperimentExposure({ isMultifamily = true } = {}) {
        // Sin asignación el usuario no participa del experimento: no hay exposure que emitir.
        if (!this.calendarExperimentAssignment) {
            return;
        }

        const isEligible = isMultifamily
            ? this.typologyIsVisitable
            : Boolean(this.selectedUnit?.is_visitable);

        if (!isEligible) {
            return;
        }

        // Native PostHog exposure: getFeatureFlag con send_event:true.
        // El SDK ya dedupea por flag+variant en $FLAG_CALL_REPORTED (persistence).
        // Solo se envía una vez por sesión aunque se llame múltiples veces.
        if (!this._calendarNativeExposureFired) {
            globalThis.assetplanFlags?.getVariant(
                FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA,
                FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA.CONTROL,
                { send_event: true }
            );
            this._calendarNativeExposureFired = true;
        }

        // Custom exposure: visit_scheduling:experiment_exposure.
        // El tracker interno ya es idempotente; _experimentExposureFired es redundante pero inofensiva.
        this.trackExperimentExposureIfEligible();
    },

    /**
     * Helper idempotente para disparar visit_scheduling:experiment_exposure.
     * Se invoca desde tres puntos del lifecycle donde la unidad puede convertirse
     * en disponible en distinto orden (onReady, fetchModels().then, checkUrlForUnit).
     * Solo dispara una vez por sesión de página.
     *
     * La lógica de tracking vive en `experiment/analytics.js#createExperimentExposureTracker`
     * (módulo ESM testeable con node --test). Este wrapper solo obtiene el analytics
     * del provider sitio_web y delega. Mantener ambos sincronizados.
     */
    trackExperimentExposureIfEligible() {
        if (this._experimentExposureFired) {
            return true;
        }

        if (!this.calendarExperimentAssignment) {
            return false;
        }

        // Elegibilidad para Multifamily: se basa en typologyIsVisitable, no en selectedUnit.
        // Esto permite que una tipología sea elegible aunque selectedUnit (elección explícita
        // del usuario) no sea visitable, siempre que otra unidad de la tipología sí lo sea.
        if (!this.typologyIsVisitable) {
            return false;
        }

        // Unidad representativa para analytics del experiment.
        // No se usa selectedUnit directamente porque puede ser no-visitable y bloquear
        // el exposure aunque la tipología sea elegible (typologyIsVisitable=true).
        // selectedUnit se usa solo si ya es visitable; si no, se busca cheapestUnitInTab
         // (que usa is_visitable, la fuente canónica para scheduling), y como último
         // recurso se recurre a experimentRepresentativeUnit (cualquier unit visitable).
        const unit =
            this.selectedUnit?.is_visitable === true
                ? this.selectedUnit
                : this.cheapestUnitInTab
                    ?? this.experimentRepresentativeUnit;

        const analytics = globalThis.assetplanAnalytics?.for('sitio_web');

        if (!analytics) {
            return false;
        }

        const tracker = this._experimentExposureTracker
            ?? (this._experimentExposureTracker = createExperimentExposureTracker({
                analytics,
                surface: 'building',
                experiment: 'ab-test-nuevo-flujo-de-agenda',
                isUnitEligible: (u) => Boolean(u?.is_visitable),
            }));

        const result = tracker.track({ variant: this.calendarExperimentAssignment, unit });

        if (result === 'fired') {
            this._experimentExposureFired = true;
            return true;
        }

        if (result === 'already') {
            this._experimentExposureFired = true;
            return true;
        }

        return false;
    },

    /**
     * Loads inline calendar slots for Aura leads or eligible organic experiment variants.
     */
    async initCalendarSlots({ autoSelectDate = true } = {}) {
        const unit = this.selectedUnit ?? this.cheapestUnitInTab;
        const unitId = parseInt(unit?.id, 10) || 0;
        if (!unitId) return;
        if (this._slotsUnitId && this._slotsUnitId !== unitId) this.showInlineCalendar = false;
        if (this._slotsUnitId && this._slotsUnitId !== unitId) this.mobileAgendaSheetOpen = false;

        const isOrganicCalendar = this.calendarExperimentVariant === 'horario-visible' && this.canScheduleVisit;

        if (!isOrganicCalendar) {
            // A late CONTROL resolution must dismantle a calendar mounted while the flag was pending.
            this.showInlineCalendar = false;
            return;
        }

        const slotsLeadId = null;
        if (
            this._slotsUnitId === unitId
            && this._slotsLeadId === slotsLeadId
            && this.hasTimeSlots()
        ) {
            // Cache hit: slots already loaded for this unit+lead.
            // Restore showInlineCalendar to true so the calendar stays visible
            // when returning to a tab whose unit matches the cached slots.
            this.showInlineCalendar = true;
            this.openAuraMobileAgendaIfReady();
            if (autoSelectDate && !this.selectedDate) {
                const first = this._firstAvailableDate(Object.keys(this._availableByDate ?? {}));
                if (first) this._selectDate(first);
            }
            return;
        }

        if (this._calendarSlotsPromise) {
            await this._calendarSlotsPromise;
            return this.initCalendarSlots({ autoSelectDate });
        }

        // initCalendarSlots() sets showInlineCalendar=false; without this guard, HV refetches leak fallback CTAs.
        this.showInlineCalendar = false;
        this.mobileAgendaSheetOpen = false;
        this.resetTimeSlots();
        const corredores = unit.building?.corredores ?? this.building?.corredores;
        const brokerId = corredores?.fijo ?? corredores?.cabecera_1 ?? null;
        let loaded = false;

        try {
            // initCalendarSlots() runs in two contexts:
            //   - HORARIO-VISIBLE organic (no lead) → V2 availability (broker filter applied at backend)
            // The variant decision is owned by the caller (this.calendarExperimentVariant);
            // passing it explicitly here keeps the mixin's CONTROL default from silently
            // desyncing availability in the HV branch.
            const variant = this.calendarExperimentVariant ?? 'control';
            const options = { autoSelectDate, variant };
            if (variant === 'horario-visible') options.minimumLoadingMs = SPINNER_MIN_MS;
            // Aura CONTROL: capability firmada V1 de availability (mismo broker que store).
            if (this.isAuraReferral && this.availabilityUrlV1 && variant === 'control') {
                options.auraAvailabilityUrl = this.availabilityUrlV1;
            }
            this._calendarSlotsPromise = this.fetchAvailableTimeSlots(slotsLeadId, unitId, 1, brokerId, options);
            loaded = await this._calendarSlotsPromise;
        } finally {
            this._calendarSlotsPromise = null;
        }

        const currentUnitId = parseInt((this.selectedUnit ?? this.cheapestUnitInTab)?.id, 10) || 0;
        this.showInlineCalendar = currentUnitId === unitId && loaded && this.hasTimeSlots();
        this.openAuraMobileAgendaIfReady();
        // Ya NO se auto-selecciona el primer slot: el usuario debe elegir explícitamente
    },

    openAuraMobileAgendaIfReady() {
        if (
            this.mobileAgendaAutoOpened
            || !this.isMobile
            || this.calendarExperimentVariant !== 'horario-visible'
            || !hasIncomingSignatureHash
            || !this.hasTimeSlots()
        ) {
            return;
        }

        const unit = this.selectedUnit ?? this.cheapestUnitInTab;
        if (!unit?.id) return;
        if (this._slotsUnitId !== Number(unit.id) || this._slotsLeadId !== null) return;

        this.selectedUnit ??= unit;
        this.mobileAgendaAutoOpened = true;
        this.mobileAgendaSheetOpen = true;
    },

    /**
     * HORARIO-VISIBLE: abre el Paso 1 (fecha y hora) desde el detalle de unidad y carga los
     * horarios V2 sin lead. Conserva la selección si se vuelve a la misma unidad.
     */
    async startSlotFirstSchedule() {
        if (!this.isSlotFirstEnabled) return;
        this.visitorFormMode = 'schedule';
        this.goTo('schedule_visit');

        const unitId = parseInt(this.selectedUnit.id, 10) || 0;
        const calendar = this.scheduleVisitCalendar;
        if (
            calendar._slotsUnitId === unitId
            && calendar._slotsVariant === 'horario-visible'
            && calendar._slotsLeadId === null
            && calendar.hasTimeSlots()
        ) {
            return;
        }

        const requestId = ++this._slotFirstRequestId;
        calendar.resetTimeSlots();
        await calendar.fetchAvailableTimeSlots(null, unitId, 1, null, {
            autoSelectDate: true,
            variant: 'horario-visible',
            minimumLoadingMs: SPINNER_MIN_MS,
            isCurrent: () => this._slotFirstRequestId === requestId,
        });
    },

    /** Auto-selecciona el primer slot disponible según el filtro AM/PM actual */
    _autoSelectFirstSlot() {
        const filteredSlots = this._getFilteredSlots();
        const firstAvailable = filteredSlots.find(s => s.available);
        if (firstAvailable) {
            this.selectedTime = firstAvailable.time;
        }
    },

    init() {
        const params = new URLSearchParams(window.location.search);

        globalThis.resetConfirmationOnDrawerClose(this);
        this.auraVisitorClearedHandler = (event) => {
            if (event.detail?.source === 'building-page') return;
            this.clearVisitorFormState();
        };
        globalThis.addEventListener('aura-referral:visitor-cleared', this.auraVisitorClearedHandler);

        // Sincronizar variante del experimento cuando el provider de flags esté listo.
        // Se lee directamente de globalThis.assetplanFlags (no de una closure stale)
        // para garantizar que se usa el provider real, no el stub.
        // Resetear solo el carrousel de horas cuando cambia la fecha (los slots son específicos por fecha)
        this.$watch('selectedDate', () => {
            this.bookingIdempotencyKey = null;
            this.timeSlotCarouselIndex = 0;
            // No resetear dateCarouselIndex — el usuario controla la página de fechas
        });

        // Resetear carrousel de horas al cambiar AM/PM
        // Ya NO se auto-selecciona el primer slot: el usuario debe elegir explícitamente
        this.$watch('timeFilter', () => {
            this.timeSlotCarouselIndex = 0;
        });

        // Verificar si la tipología está presente en la URL y agregarla si no está
        this.ensureTypologyInUrl();

        // Cargar filtros desde la URL
        this.loadFiltersFromUrl();

        // Verificar si hay una unidad en la URL para abrirla
        this.checkUrlForUnit();

        // A/B test botón QQMC y calendario: onReady dispara inmediatamente en dev (console provider)
        // y espera a PostHog en producción. Se lee directamente de globalThis.assetplanFlags
        // para garantizar que se usa el provider real, no una referencia stale.
        // Fallback: si PostHog no responde en 1000ms, renderizar CONTROL sin asignación
        // (el lead no se registra como participante del experimento).
        const postHogTimeout = setTimeout(() => {
            if (!this.experimentVariantResolved) {
                this.calendarExperimentAssignment = null;
                this.calendarExperimentVariant = FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA.CONTROL;
                globalThis.calendarExperimentAssignment = null;
                globalThis.calendarExperimentVariant = this.calendarExperimentVariant;
                this.experimentVariantResolved = true;
                this.initCalendarSlots();
            }
        }, 1000);

        globalThis.assetplanFlags?.onReady(() => {
            clearTimeout(postHogTimeout);
            // Si el fallback ya resolvió la variante (PostHog llegó tarde),
            // no sobrescribir la variante para evitar inconsistencia mid-session.
            // El usuario ya está interactuando con CONTROL; cambiar a HV rompería la UI.
            if (this.experimentVariantResolved) {
                return;
            }
            this.ctaBotonQqmcVariant = globalThis.assetplanFlags.isEnabled(FLAG.AB_TEST_BOTON_QQMC)
                ? globalThis.assetplanFlags.getVariant(FLAG.AB_TEST_BOTON_QQMC)
                : FLAG.AB_TEST_BOTON_QQMC.CONTROL;
            globalThis.ctaBotonQqmcVariant = this.ctaBotonQqmcVariant;
            // Resuelve la variante sin emitir $feature_flag_called.
            // getVariant(send_event:false) evita exposure prematuro antes de conocer
            // la elegibilidad de la tipología (typologyIsVisitable).
            // El fallback es `false` (no participa) y no CONTROL, para no confundir a quien queda
            // fuera del experimento con quien fue asignado a la variante control.
            const rawCalendarVariant = globalThis.assetplanFlags.getVariant(
                FLAG.ABC_TEST_NUEVO_FLUJO_DE_AGENDA,
                false,
                { send_event: false }
            );
            // Asignación real: null si el usuario no participa (false o valor fuera de la lista).
            this.calendarExperimentAssignment = normalizeExperimentVariant(rawCalendarVariant);
            // Variante de UI: normaliza solo-agenda → horario-visible y lleva a CONTROL a quien
            // no participa, para que los CTA siempre tengan una variante válida.
            this.calendarExperimentVariant = resolveCalendarExperimentVariant(rawCalendarVariant);

            globalThis.calendarExperimentAssignment = this.calendarExperimentAssignment;
            globalThis.calendarExperimentVariant = this.calendarExperimentVariant;
            this.experimentVariantResolved = true;
            this.initCalendarSlots();

            // Asegurar exposure del experimento: getVariant(send_event:false) en onReady
            // no emite $feature_flag_called. ensureCalendarExperimentExposure() se encarga
            // de disparar el native exposure (send_event:true) y el custom exposure
            // cuando typologyIsVisitable sea true, de forma idempotente.
            this.ensureCalendarExperimentExposure({ isMultifamily: true });
        });

        // --- Listeners de agenda ---
        // Se registran FUERA de onReady para evitar la condición de carrera:
        // cuando PostHog responde después del timeout de 1000ms, el fallback establece
        // experimentVariantResolved=true y onReady retorna sin registrar listeners.
        // Ahora los listeners se attachan aquí una sola vez, independientemente del timing
        // de PostHog, y leen calendarExperimentVariant que ya está resuelto
        // (por el fallback o por la respuesta normal de PostHog).
        //
        // Guard idempotente: si `init()` de Alpine se volviera a ejecutar
        // (por ejemplo, re-mount del componente parent), no queremos
        // duplicar listeners: cada duplicado multiplicaría los tracks
        // hacia PostHog.
        if (!this._experimentListenersAttached) {
            this._experimentListenersAttached = true;
            window.addEventListener('visit_scheduling:date_pick', (e) => {
                // buildDatePickPayload vive en resources/js/portal_assetplan/experiment/analytics.js
                // (expuesto en window.__experiment.buildDatePickPayload). Lo usamos para
                // que las pruebas de node --test cubran exactamente la misma forma de payload
                // que recibe PostHog, sin redefinir inline un objeto paralelo.
                const build = globalThis.__experiment?.buildDatePickPayload;
                const variant = globalThis.__experiment?.normalizeVariant
                    ? globalThis.__experiment.normalizeVariant(this.calendarExperimentVariant)
                    : this.calendarExperimentVariant;
                const payload = build
                    ? build({ date: e.detail?.date, variant, surface: 'building' })
                    : { date: e.detail?.date, variant, surface: 'building' };
                globalThis.assetplanAnalytics?.for('sitio_web').track('visit_scheduling:date_pick', payload);
            });

            window.addEventListener('visit_scheduling:time_pick', (e) => {
                const build = globalThis.__experiment?.buildTimePickPayload;
                const variant = globalThis.__experiment?.normalizeVariant
                    ? globalThis.__experiment.normalizeVariant(this.calendarExperimentVariant)
                    : this.calendarExperimentVariant;
                const payload = build
                    ? build({ time: e.detail?.time, date: this.selectedDate, variant, surface: 'building' })
                    : { time: e.detail?.time, date: this.selectedDate, variant, surface: 'building' };
                globalThis.assetplanAnalytics?.for('sitio_web').track('visit_scheduling:time_pick', payload);
            });

            // ponytail: cuando el POST a schedule-visit devuelve 422 (slot dejó de estar disponible),
            // el drawer schedule-visit dispatcha este evento. Recargamos los slots del calendario
            // inline y reseteamos selectedTime/selectedDate para que el usuario re-elige.
            window.addEventListener('visit_scheduling:slot_conflict', (e) => {
                this.selectedTime = null;
                this.selectedDate = null;
                this.reloadTimeSlots();
                this.triggerToast(e.detail?.message ?? 'Ese horario ya no está disponible. Elige otro.', 'error');
            });

            // B/C mobile: al confirmar agenda exitosamente, cerrar el sheet del calendario inline
            window.addEventListener('visit_scheduling:success', () => {
                this.mobileAgendaSheetOpen = false;
            });

            // HORARIO-VISIBLE desktop: cuando el componente schedule-visit rechaza abrir el drawer
            // porque no hay slot preseleccionado, mostramos el Inline Calendar en la página
            // (init si hace falta) y hacemos scroll. Es la salida funcional exigida por el fix
            // del bug "drawer en blanco" en HORARIO-VISIBLE sin slot.
            window.addEventListener('schedule-visit-show-inline-calendar', async () => {
                if (globalThis.calendarExperimentVariant !== 'horario-visible') return;
                await this.openInlineCalendarOnPage();
            });

            // Breakpoint-change listener: close transient UI when crossing lg breakpoint.
            // Idempotent (guarded by _experimentListenersAttached).
            const mq = window.matchMedia('(max-width: 1023px)');
            const handleBreakpointChange = () => {
                // Policy: reset transient mobile UI and close drawers on ANY breakpoint crossing.
                this.isMobile = mq.matches;
                this.mobileAgendaSheetOpen = false;
                this.showInlineCalendar = false;
                window.dispatchEvent(new CustomEvent('schedule-visit-close'));
                window.dispatchEvent(new CustomEvent('im-interested-close'));
                // Restore inline calendar when returning to desktop with cached HORARIO-VISIBLE slots.
                // initCalendarSlots() hits cache (no network call) and sets showInlineCalendar = true
                // when unit+lead slots are already loaded; returns early if not HORARIO-VISIBLE,
                // not visitable, or cache miss (no pre-existing slots). No guard needed for
                // in-flight requests — the function's own promise guard deduplicates them.
                if (
                    !this.isMobile &&
                    this.experimentVariantResolved &&
                    this.calendarExperimentVariant === 'horario-visible' &&
                    this.typologyIsVisitable
                ) {
                    this.initCalendarSlots();
                }
            };
            mq.addEventListener('change', handleBreakpointChange);
            // Run once to sync state on initial load (e.g., if page loads at mobile width)
            if (mq.matches) {
                handleBreakpointChange();
            }
        }

        // Watch for selectedUnit changes to trigger quote
        this.$watch('selectedUnit', (newValue, oldValue) => {
            this.bookingIdempotencyKey = null;
            if (newValue?.id) {
                // Evitar doble llamada si es la misma unidad y los parámetros derivados no han cambiado
                if (oldValue?.id === newValue.id &&
                    this.quoteParams.unit_id === newValue.id &&
                    this.quoteParams.want_parking === (newValue.has_parking || false) &&
                    this.quoteParams.want_store === (newValue.has_store || false)) {
                    return;
                }

                this.quoteParams.unit_id = newValue.id;
                this.quoteParams.want_parking = newValue.has_parking || false;
                this.quoteParams.want_store = newValue.has_store || false;
                //this.quoteParams.want_pet = newValue.acepta_mascotas || false;
                this.quoteParams.want_pet = false;
                this.getQuote();

                if(globalThis.assetplanAnalytics) {
                    let statusText = 'Lista para arrendar';
                    if(newValue.estado_vacios === 9){
                        statusText = 'Desarrollo inmobiliario';
                    } else if(newValue.estado_vacios === 12){
                        statusText = 'Re-acondicionamiento';
                    }
                    globalThis.assetplanAnalytics.for('sitio_web').track('unit_select', {
                        building: this.building.name,
                        unit_status: statusText,
                    })
                }

                // Actualizar URL cuando seleccionamos una unidad
                // Usar $nextTick para asegurar que el step se haya actualizado si viene de goTo()
                this.$nextTick(() => {
                    if (this.step === 'detail' || this.openDrawerUnits) {
                        this.updateUrlUnit(newValue.id);
                    }
                });
            } else if (oldValue?.id) {
                this.updateUrlUnit(null);
            }

            this.initCalendarSlots();
        });

        this.$watch('selectedTime', () => { this.bookingIdempotencyKey = null; });
        this.$watch('scheduleVisitCalendar.selectedDate', () => { this.bookingIdempotencyKey = null; });
        this.$watch('scheduleVisitCalendar.selectedTime', () => { this.bookingIdempotencyKey = null; });
        this.$watch('profileForm.movingTimeline', () => { this.bookingIdempotencyKey = null; });
        this.$watch('profileForm.hasIncome', () => { this.bookingIdempotencyKey = null; });
        this.$watch('leadId', () => { this.bookingIdempotencyKey = null; });

        this.$watch('quoteParams.want_parking', () => {
            if (this.quoteParams.unit_id) this.getQuote();
        });
        this.$watch('quoteParams.want_store', () => {
            if (this.quoteParams.unit_id) this.getQuote();
        });
        this.$watch('quoteParams.want_pet', () => {
            if (this.quoteParams.unit_id) this.getQuote();
        });
        this.$watch('quoteParams.warranty_type', () => {
            if (this.quoteParams.unit_id) this.getQuote();
        });

        this.$watch('isAnyDrawerOpen', value => {
            if (value) {
                document.body.classList.add('overflow-hidden');
            } else {
                document.body.classList.remove('overflow-hidden');
            }
        });
        this.tabs = this.sortTypologies(this.tabs);
        
        // Initial fetch for active tab (OD)
        if (this.activeTab) {
             this.isLoadingModels = true;
              this.fetchModels(this.activeTab).then(async () => {
                 // try/finally: si algo lanza, isLoadingModels igual se apaga; de lo contrario
                 // el wrapper de CTAs (x-show="!isLoadingModels") queda oculto para siempre.
                 try {
                     this.updateCurrentGroups(this.activeTab);
                     this.updateCurrentModels(this.activeTab);
                     // Recién acá cheapestUnitInTab tiene datos: initCalendarSlots() sale temprano sin ellos.
                     // Se espera antes de apagar isLoadingModels para que el spinner cubra también el fetch
                     // de available-hours; si no, se ve un hueco con los CTAs legacy antes del calendario.
                     await this.initCalendarSlots();
                 } finally {
                     this.isLoadingModels = false;
                 }

                 // Call site 2: cheapestUnitInTab ya está disponible desde allGroupedUnits.
                 this.trackExperimentExposureIfEligible();
              });
        }

        this.updateBuildingPrices(this.activeTab);

        this.$nextTick(() => {
            const fixed = this.$refs.fixedBox;
            if (fixed) {
                // ponytail: un ResizeObserver cubre los tres casos de cambio de alto (expandir/colapsar el
                // bottom sheet, crecer el calendario al elegir fecha, cruzar el breakpoint lg) sin watchers extra.
                // Solo compensa cuando el panel está fuera de flujo (position:fixed = mobile);
                // en desktop es sticky, no tapa nada, y el padding-bottom debe ser 0.
                const measureBottomBox = () => {
                    this.bottomHeight = getComputedStyle(fixed).position === 'fixed' ? fixed.offsetHeight : 0;
                };
                measureBottomBox();
                new ResizeObserver(measureBottomBox).observe(fixed);
            }

            window.addEventListener('modal-share', () => {
                this.showModalShare = true;
            });

            window.addEventListener('share-done', () => {
                this.copyDone = true;
                setTimeout(() => { this.copyDone = false; }, 2000);
            });
        });

        window.addEventListener("scroll", () => this.handleScroll());

        // Cargar mapas estáticos
        this.$nextTick(() => {
            this.loadMap('mapa-building-multifamily', 10);
        });

        // Manejar navegación del browser (botón back del navegador)
        window.addEventListener('popstate', (event) => {
            if (this.openDrawerUnits) {
                this.handleBrowserBack(event);
            }
        });  
       
        // Usar el sistema completo de Referral.js
        // Leer UTMs desde window.utm (cubre URL actual + localStorage) en lugar de sólo params de URL
        this.formDataContactme.refer_code = referral.refer_code ?? (window.referralCode ? window.referralCode.getValue() : '');
        const utmStored = window.utm ? (JSON.parse(window.utm.getValue() || 'null') || {}) : {};
        this.formDataContactme.utm_source = utmStored.utm_source || params.get('utm_source') || '';
        this.formDataContactme.utm_medium = utmStored.utm_medium || params.get('utm_medium') || '';
        this.formDataContactme.utm_campaign = utmStored.utm_campaign || params.get('utm_campaign') || '';
        this.formDataContactme.utm_content = utmStored.utm_content || params.get('utm_content') || '';
        this.formDataContactme.utm_term = utmStored.utm_term || params.get('utm_term') || '';
        this.formDataContactme.fbclid = window.fbclid ? window.fbclid.getValue() : (params.get('fbclid') || '');
        this.formDataContactme.gclid  = window.gclid  ? window.gclid.getValue()  : (params.get('gclid')  || '');
    },

    destroy() {
        if (this.auraVisitorClearedHandler) {
            globalThis.removeEventListener('aura-referral:visitor-cleared', this.auraVisitorClearedHandler);
        }
    },

    /**
     * Alias de selectedUnit para compatibilidad con los partials (unit-card, visit-success).
     * Devuelve la unidad seleccionada o la más barata disponible en la tipología activa.
     */
    get unit() {
        return this.selectedUnit || this.cheapestUnitInTab;
    },

    get isAnyDrawerOpen() {
        return this.openDrawerUnits || this.openDrawerMultifamily || this.openDrawerAvailable || this.openDrawerUnitNotFound || this.openModalGallery || this.showContactMeModal;
    },

    /**
     * Unidad disponible con menor precio del edificio.
     * Se usa como fallback cuando no hay selectedUnit al abrir un drawer.
     */
    get cheapestUnit() {
        const available = (this.units || []).filter(u => u.estado_vacios === 8);
        if (!available.length) return null;
        return available.reduce((cheapest, unit) => {
            const price = unit.price?.monto_depto ?? Infinity;
            const cheapestPrice = cheapest?.price?.monto_depto ?? Infinity;
            return price < cheapestPrice ? unit : cheapest;
        }, null);
    },

    /**
     * Indica si la tipología activa tiene al menos una unidad visitable.
     * Fuente: todas las unidades belonging a la tipología activa (activeTab).
     * NO usa estado_vacios como condición — solo unit.is_visitable (que internamente incluye estado_vacios).
     */
    get typologyIsVisitable() {
        const models = this.allGroupedUnits[this.activeTab];
        return (models ?? [])
            .flatMap(model => model.unidades ?? [])
            .some(unit => unit.is_visitable === true);
    },

    get canScheduleVisit() {
        const unit = this.selectedUnit ?? this.cheapestUnitInTab;

        return unit?.is_visitable === true && Number(unit?.no_publicar ?? 0) !== 1;
    },

    /**
     * Unidad visitable con menor precio dentro de la tipología (tab) activa.
     *
     * Fuente: `allGroupedUnits[activeTab]` — array de modelos con campo `unidades`
     * populado por fetchModels(). Las unidades tienen `is_visitable` desde BuildingController
     * (processUnitsForListing). Si el tab aún no se cargó, retorna null.
     */
    get cheapestUnitInTab() {
        const models = this.allGroupedUnits[this.activeTab];
        if (!models || !models.length) return null;

        const available = models
            .flatMap(model => model.unidades ?? [])
            .filter(u => u.is_visitable === true);

        if (!available.length) return null;

        return available.reduce((cheapest, unit) => {
            const price = unit.price?.monto_depto ?? Infinity;
            return price < (cheapest?.price?.monto_depto ?? Infinity) ? unit : cheapest;
        }, null);
    },

    /**
     * Unidad representativa de analytics para el experiment exposure.
     *
     * Desacoplada de selectedUnit y cheapestUnitInTab para evitar que una
     * selectedUnit no-visitable o un cheapestUnitInTab==null bloquen el
     * custom exposure cuando la tipología ES elegible (typologyIsVisitable=true).
     *
     * Regla: cualquier unit visitable del activeTab. No filtra por estado_vacios.
     * Retorna null solo si no hay ninguna unidad con is_visitable=true.
     */
    get experimentRepresentativeUnit() {
        const models = this.allGroupedUnits[this.activeTab];
        return (models ?? [])
            .flatMap(model => model.unidades ?? [])
            .find(unit => unit.is_visitable === true) ?? null;
    },

    get cheapestContactableUnitInTab() {
        const models = this.allGroupedUnits[this.activeTab];
        if (!models || !models.length) return null;

        const units = models.flatMap(model => model.unidades ?? []);
        if (!units.length) return null;

        return units.reduce((cheapest, unit) => {
            const price = unit.price?.monto_depto ?? Infinity;
            return price < (cheapest.price?.monto_depto ?? Infinity) ? unit : cheapest;
        }, units[0]);
    },

    /**
     * Unidad para el drawer im-interested cuando no hay una seleccionada: la más barata del tab
     * activo y, si el tab no tiene unidades, la más barata del edificio. im-interested envía su
     * unit_id al crear el lead y lo usa para el agendamiento posterior.
     */
    get contactUnit() {
        if (this.cheapestContactableUnitInTab) return this.cheapestContactableUnitInTab;

        const units = [
            ...Object.values(this.allGroupedUnits ?? {}).flat().flatMap(model => model?.unidades ?? []),
            ...(this.units ?? []),
        ].filter(unit => unit?.id);
        if (!units.length) return null;

        return units.reduce((cheapest, unit) => {
            const price = unit.price?.monto_depto ?? Infinity;
            return price < (cheapest.price?.monto_depto ?? Infinity) ? unit : cheapest;
        }, units[0]);
    },

    get navigationTitle() {
        if (this.step === 'list') return 'Seleccionar departamento';
        if (this.step === 'detail') return 'Departamento ' + (this.selectedUnit?.unidad || '');
        if (this.step === 'equipment') return 'Equipamiento';
        if (this.step === 'unit_photos') return 'Galería unidad ' + (this.selectedUnit?.unidad || '');
        if (this.step === 'no_availability') return 'Agendar visita';
        if (this.step === 'contact_me') return 'Solicitar contacto';
        if (this.step === 'visitor_form') return this.visitorFormMode === 'interest' ? 'Me interesa' : 'Agendar visita';
        if (this.step === 'schedule_visit') return 'Agendar visita';
        if (this.step === 'schedule_confirmation') return 'Agendar visita';
        if (this.step === 'schedule_success') return '';
        if (this.step === 'success_with_schedule') return '';
        return '';
    },

    get navigationShowBack() {
        // En schedule_success y success_with_schedule no se muestra el botón back
        if (this.step === 'schedule_success') return false;
        if (this.step === 'success_with_schedule') return false;
        return this.history?.length > 0;
    },

    // ============================================================
    // Visitor form — computed getters
    // ============================================================
    // ============================================================
    // Similar buildings carousel (usado por similar-buildings-carousel
    // y visit-success directamente en el scope buildingPage)
    // ============================================================
    similarBuildingsDisplay() {
        if (!this.similarBuildings.length) return [];
        return [...this.similarBuildings, this.similarBuildings[0]];
    },
    sbNext() {
        const len = this.similarBuildings.length;
        if (!len) return;
        this._sbTransition = true;
        this.similarBuildingsIndex++;
        if (this.similarBuildingsIndex === len) {
            setTimeout(() => {
                this._sbTransition = false;
                this.similarBuildingsIndex = 0;
                requestAnimationFrame(() => requestAnimationFrame(() => {
                    this._sbTransition = true;
                }));
            }, 320);
        }
    },
    sbPrev() {
        const len = this.similarBuildings.length;
        if (!len) return;
        this._sbTransition = true;
        this.similarBuildingsIndex = this.similarBuildingsIndex === 0 ? len - 1 : this.similarBuildingsIndex - 1;
    },
    resetSimilarBuildings() {
        this.similarBuildings      = [];
        this.similarBuildingsIndex = 0;
        this._sbTransition         = true;
    },

    get canSubmitVisitorForm() {
        return (this.form?.full_name ?? '').trim() &&
               (this.form?.rut ?? '').trim() &&
               this.validateRut(this.form?.rut) &&
               /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.form?.email ?? '') &&
               (this.form?.phone ?? '').length >= 8 &&
               (this.form?.phone ?? '').length <= 15 &&
               this.form?.terms &&
            ((this.form?.movingTimeline !== null && this.showMovingTimeline) || !this.showMovingTimeline);
    },

    /**
     * Plazo de mudanza que se envía al agendar. Si ya se respondió en el formulario
     * de visitante (modo "me interesa") se reutiliza; si no, se toma del paso de perfil.
     */
    get effectiveMovingTimeline() {
        return this.form?.movingTimeline ?? this.profileForm.movingTimeline;
    },

    get canSubmitProfile() {
        return this.profileForm.hasIncome !== null && this.effectiveMovingTimeline !== null;
    },

    /**
     * HORARIO-VISIBLE: "Agendar visita" en el detalle de unidad parte por el horario
     * (Paso 1 schedule_visit → Paso 2 visitor_form → Paso 3 schedule_confirmation).
     */
    get isSlotFirstEnabled() {
        return this.calendarExperimentVariant === 'horario-visible' && !!this.selectedUnit?.is_visitable;
    },

    /**
     * El flujo de agenda en curso partió por el horario desde el detalle. Se deriva del historial:
     * el último schedule_visit vino directo de detail. El reintento por horario tomado (422) vuelve
     * a schedule_visit desde schedule_confirmation y retoma el flujo original.
     */
    get isSlotFirstFlow() {
        if (this.visitorFormMode !== 'schedule' || !this.isSlotFirstEnabled) return false;
        const trail = [...this.history, this.step];
        const scheduleIndex = trail.lastIndexOf('schedule_visit');

        return scheduleIndex > 0 && trail[scheduleIndex - 1] === 'detail';
    },

    get shouldOfferScheduling() {
        const unit = this.selectedUnit ?? this.cheapestUnitInTab;
        return unit?.is_visitable && this.form?.movingTimeline !== null && this.form?.movingTimeline <= 45;
    },


    async goTo(nextStep) {
        // Agregar feedback visual durante la navegación
        this.isNavigating = true;
        this.navigationDirection = 'forward';

        // Agregar el paso actual al historial
        this.history.push(this.step);

        // Si estamos navegando fuera de detail (y no es a unit_photos), limpiar unit_id
        if (this.step === 'detail' && nextStep !== 'detail' && nextStep !== 'unit_photos') {
            this.updateUrlUnit(null);
        }

        if(nextStep === 'visitor_form' && this.visitorFormMode === 'schedule') {
            this.showMovingTimeline = false;
            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:start_button_click', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                    from: 'landing',
                    property_state: this.selectedUnit?.is_visitable ? 'available' : 'not_available',
                    experiment: this.calendarExperimentVariant === 'horario-visible' ? 'ABC_SV_horario-visible' : 'ABC_SV_control',
                })
            }
        }


        if(nextStep === 'visitor_form' && this.visitorFormMode === 'interest') {
            this.showMovingTimeline = true;
            this.trackActionStart('contact_me', 'unit');
        }

        if(nextStep === 'schedule_confirmation') {
            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:date_select', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                    origin: this.visitorFormMode === 'schedule' ? 'visit_scheduling' : 'im_intrerested',
                })
            }
        }

        if(nextStep === 'schedule_success') {
            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:summary_page_view', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                    origin: this.visitorFormMode === 'schedule' ? 'visit_scheduling' : 'im_intrerested',
                })
            }
        }

        // Si nextStep es contact_me hago el fetch al controlador contactme para obtener hasbroker
        if(nextStep === 'contact_me'){
           await this.fetchContactmeController();
            this.trackActionStart('contact_me', 'unit');
        }
        

        const executeGoTo = () => {
            this.step = nextStep;
            this.resetScroll();

            this.$nextTick(() => {
                setTimeout(() => {
                    this.isNavigating = false;
                }, 300);
            });
        };

        if (document.startViewTransition) {
            document.startViewTransition(() => executeGoTo());
        } else {
            executeGoTo();
        }
    },
  
    back() {
        if (this.history.length > 0) {
            // Validar que no estemos ya navegando
            if (this.isNavigating) {
                return;
            }

            // Agregar feedback visual durante la navegación hacia atrás
            this.isNavigating = true;
            this.navigationDirection = 'backward';

            // Obtener el paso previo ANTES de entrar en el async
            const previousStep = this.history.pop();

            // Si estamos saliendo de detail (y no volvemos a unit_photos), limpiar unit_id de la URL
            // Mantener selectedUnit para evitar el parpadeo de placeholders durante la animación
            if (this.step === 'detail' && previousStep !== 'detail' && previousStep !== 'unit_photos') {
                this.updateUrlUnit(null);
            } else if (this.step === 'unit_photos' && previousStep !== 'detail') {
                this.updateUrlUnit(null);
            }

            const executeBack = () => {
                const oldStep = this.step;
                this.step = previousStep;
                this.resetScroll();

                // Mantener actualizada la lista si volvemos desde el detalle
                if (this.step === 'list' && oldStep === 'detail') {
                    this.refreshModelUnits(true); // showLoading = true como solicitó el usuario
                }

                // Limpiar la unidad seleccionada solo después de que la transición haya avanzado
                // o cuando volvemos a la lista principal
                setTimeout(() => {
                    this.isNavigating = false;
                    if (this.step === 'list') {
                        this.selectedUnit = null;
                    }
                }, 300);
            };

            if (document.startViewTransition) {
                document.startViewTransition(() => executeBack());
            } else {
                executeBack();
            }
        } else {

            // Si no hay historial, cerrar el drawer como fallback
            this.closeDrawer();
        }
    },

    handleBrowserBack(event) {
        // Prevenir el comportamiento por defecto si estamos navegando dentro del drawer
        if (this.history.length > 0 && this.openDrawerUnits) {
            event.preventDefault();
            this.back();
        } else if (this.openDrawerUnits) {
            // Si no hay historial pero el drawer está abierto, cerrarlo
            event.preventDefault();
            this.closeDrawer();
        }
    },

    resetScroll() {
        this.$nextTick(() => {
            const container = document.getElementById('drawer-navigation-content');
            if (container) container.scrollTop = 0;
        });
    }, 
   
    closeDrawer() {
        // Agregar feedback visual al cerrar
        this.isNavigating = true;
        this.openDrawerUnits = false;

        // Limpiar unit_id de la URL inmediatamente
        this.updateUrlUnit(null);

        // HORARIO-VISIBLE: invalida la carga del Paso 1 en curso y descarta el horario elegido,
        // así una respuesta tardía no repuebla el calendario y el próximo intento parte limpio.
        this._slotFirstRequestId++;
        this.scheduleVisitCalendar.resetTimeSlots();

        setTimeout(async () => {
            this.step = 'list';
            this.history = [];
            this.selectedUnit = null;
            this.isNavigating = false;
            this.resetVisitorFlow();
            // Slots are refetched for the active unit, so the previous date may no longer exist;
            // preserving it can mark a day with no hours, worse than selecting the first available date.
            await this.initCalendarSlots({ autoSelectDate: true });
        }, 300);
    },

    // ============================================================
    // Visitor form — métodos
    // ============================================================

    resetVisitorFlow() {
        this.form = { ...createAuraReferralFormWithRut(referral, this.effectiveRut), terms: false, movingTimeline: null };
        this.visitorFormMode = 'schedule';
        this.errors = { name: '', last_name: '', rut: '', email: '', phone: '', terms: '', reason: '' };
        this.resetTimeSlots();
        this.profileForm = { movingTimeline: null, hasIncome: null };
        this.bookingIdempotencyKey = null;
        this.reqOpen = false;
        this.sending = false;
        this.leadId = null;
        this.brokerId = null;
        this.similarBuildings      = [];
        this.similarBuildingsIndex = 0;
        this._sbTransition         = true;
    },

    /**
     * Abre el drawer autónomo schedule-visit desde los CTAs externos (sticky bar).
     *
     * Comportamiento por variante:
     * - CONTROL: abre el drawer (cualquier device).
     * - HORARIO-VISIBLE mobile: abre el mobileAgendaSheetOpen (bottom sheet con el Inline Calendar).
     * - HORARIO-VISIBLE desktop sin slot preseleccionado: muestra el Inline Calendar en la página
     *   (init si hace falta, scrollIntoView) — NUNCA abre el drawer en paso 'schedule' oculto.
     * - HORARIO-VISIBLE desktop con slot preseleccionado: cae al dispatcher normal (el listener
     *   @schedule-visit-open ignora eventos sin slot, por lo que este camino solo se activa si el
     *   llamador ya pasó por confirmSlot/confirmSlotWithLead).
     */
    openScheduleVisit() {
        if (!this.selectedUnit) this.selectedUnit = this.cheapestUnitInTab;
        const unit     = this.selectedUnit;
        if (!this.canScheduleVisit) return;
        const building = unit?.building ?? this.building;

        const isMobile = window.matchMedia('(max-width: 1023px)').matches;
        const variant = this.calendarExperimentVariant;
        const isExperimentalAgenda = variant === 'horario-visible';

        // Mobile + HORARIO-VISIBLE: bottom sheet con el Inline Calendar.
        if (isMobile && isExperimentalAgenda) {
            this.mobileAgendaSheetOpen = true;
            return;
        }

        // Desktop + HORARIO-VISIBLE sin slot: el calendario debe estar en la página, no en un
        // drawer con paso 'schedule' oculto. Si no está visible, intentar cargarlo; si ya está,
        // solo hacer scroll.
        if (!isMobile && isExperimentalAgenda && !this.selectedDate && !this.selectedTime) {
            this.openInlineCalendarOnPage();
            return;
        }

        window.dispatchEvent(new CustomEvent('schedule-visit-open', {
            detail: { unit_id: unit?.id, building },
        }));

        if(globalThis.assetplanAnalytics){
            globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:start_button_click', {
                building_type: building.multifamily ? 'multifamily' : 'retail',
                from: 'landing',
                property_state: 'available',
                experiment: this.calendarExperimentVariant === 'horario-visible' ? 'ABC_SV_horario-visible' : 'ABC_SV_control',
            })
        }
    },

    /**
     * Muestra el Inline Calendar en la página para variantes B/C (HORARIO-VISIBLE) cuando el
     * usuario hace click en un CTA sin haber seleccionado slot. Dispara la carga si todavía no
     * fue inicializado y hace scroll suave hacia él. Nunca abre el drawer.
     *
     * El init real es initCalendarSlots (definido en este mismo factory), que es
     * quien controla showInlineCalendar y _slotsError.
     */
    async openInlineCalendarOnPage() {
        if (typeof this.initCalendarSlots === 'function') {
            await this.initCalendarSlots();
        }
        this.showInlineCalendar = !!this.hasTimeSlots?.();
        if (typeof this.sheetExpanded === 'boolean') this.sheetExpanded = false;

        // Scroll al calendario inline (unidades múltiples) o al sticky box (página de unidad).
        await new Promise(r => requestAnimationFrame(r));
        const target = document.querySelector('[data-inline-calendar-root]')
            ?? document.querySelector('x-new-web-components-shared-partials-inline-calendar');
        target?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },

    /**
     * Reintenta la carga del calendario cuando la primera intento falló. Resetea
     * el estado de error y vuelve a llamar a initCalendarSlots.
     */
    async retryInlineCalendar() {
        this._slotsError = false;
        this.showInlineCalendar = false;
        await this.initCalendarSlots();
        this.showInlineCalendar = !!this.hasTimeSlots?.();
    },

    /**
     * Preview local de la ventana de ScheduleVisitController: 7 días agendables desde mañana
     * (los domingos no cuentan). El backend corre la ventana un día cuando la anticipación mínima
     * de 24 horas cae después del último slot de mañana, y aplica la regla por slot.
     */
    previewDays() {
        const days = [];
        const today = new Date(); today.setHours(0, 0, 0, 0);
        for (let i = 1; days.length < 7; i++) {
            const d = new Date(today);
            d.setDate(today.getDate() + i);
            if (d.getDay() === 0) continue; // skip Sunday
            const iso = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
            days.push({ iso, date: d, available: true, hasFreeSlot: true });
        }
        return days;
    },

    /** Opens the organic scheduling drawer with the selected slot. */
    confirmSlot() {
        if (!this.selectedDate || !this.selectedTime || this.confirmingSlot) return;
        const unit = this.selectedUnit ?? this.cheapestUnitInTab;
        if (!unit?.id) return;

        this.confirmingSlot = true;

        window.dispatchEvent(new CustomEvent('schedule-visit-open-with-slot', {
            detail: {
                unit_id: unit.id,
                building: unit.building ?? this.building,
                date: this.selectedDate,
                time: this.selectedTime,
                dispatchEvent: true,
            },
        }));
    },

    /**
     * Aura uses the same drawer as organic traffic. The drawer submits the
     * signatureHash and receives the signed scheduling capability server-side.
     */
    confirmSlotWithLead() {
        return this.confirmSlot();
    },

    /**
     * Abre el drawer autónomo im-interested desde los CTAs externos (sticky bar).
     */
    openImInterested() {
        if (!this.selectedUnit) this.selectedUnit = this.contactUnit;
        const unit     = this.selectedUnit;
        const building = this.building;
        if (!unit?.id) {
            this.triggerToast('No pudimos cargar el departamento. Recarga la página e inténtalo nuevamente.', 'error');
            return;
        }
        window.dispatchEvent(new CustomEvent('im-interested-open', {
            detail: { unit, building },
        }));

        this.trackActionStart('contact_me', 'landing');
    },

    validateVisitorField(field) {
        const f = this.form;
        if (field === 'name') {
            this.errors.name = f.full_name.trim() ? '' : 'El nombre es requerido';
        }
        if (field === 'rut') {
            if (!f.rut.trim()) {
                this.errors.rut = 'El RUT es requerido';
            } else if (!this.validateRut(f.rut)) {
                this.errors.rut = 'El RUT ingresado no es válido';
            } else {
                this.errors.rut = '';
            }
        }
        if (field === 'email') {
            if (!f.email.trim()) {
                this.errors.email = 'El correo es requerido';
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) {
                this.errors.email = 'Ingresa un correo válido';
            } else {
                this.errors.email = '';
            }
        }
        if (field === 'phone') {
            if (!f.phone.trim()) {
                this.errors.phone = 'El teléfono es requerido';
            } else if (f.phone.length > 15) {
                this.errors.phone = 'El teléfono no puede tener más de 15 dígitos';
            } else if (f.phone.length < 8) {
                this.errors.phone = 'Ingresa un número válido (mínimo 8 dígitos)';
            } else {
                this.errors.phone = '';
            }
        }
        if (field === 'terms') {
            this.errors.terms = f.terms ? '' : 'Debes aceptar los términos';
        }
    },

    validateRut(rut) {
        if (!rut || typeof rut !== 'string') return false;
        const cleaned = rut.replace(/[^0-9kK]/g, '');
        if (cleaned.length < 8) return false;
        const body = cleaned.slice(0, -1);
        const dv = cleaned.slice(-1).toLowerCase();
        let sum = 0;
        let multiplier = 2;
        for (let i = body.length - 1; i >= 0; i--) {
            sum += parseInt(body[i]) * multiplier;
            multiplier = multiplier === 7 ? 2 : multiplier + 1;
        }
        const expectedDv = 11 - (sum % 11);
        const expectedDvStr = expectedDv === 11 ? '0' : expectedDv === 10 ? 'k' : String(expectedDv);
        return dv === expectedDvStr;
    },

    formatRut(value) {
        if (!value) return '';
        let cleaned = value.replace(/[^0-9kK]/g, '');
        if (cleaned.length === 0) return '';
        cleaned = cleaned.slice(0, 9);
        if (cleaned.length < 2) return cleaned;
        let body = cleaned.slice(0, -1);
        let dv = cleaned.slice(-1).toUpperCase();
        let formattedBody = body.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return formattedBody + '-' + dv;
    },

    formatPhone(digits, code) {
        if (!digits) return '';
        const d = String(digits).replace(/\D/g, '').slice(0, 15);
        if (code === '56') {
            const c = d.slice(0, 9);
            if (c.length <= 1) return c;
            if (c.length <= 5) return c[0] + ' ' + c.slice(1);
            return c[0] + ' ' + c.slice(1, 5) + ' ' + c.slice(5);
        }
        return d;
    },

    /**
     * Envía el formulario de contacto (visitor_form).
     * Crea el Lead via POST /im-interested, guarda lead_id.
     * Si la unidad es visitable → schedule_visit; si no → schedule_success.
     */
    async submitVisitorForm() {
        this.validateVisitorField('name');
        this.validateVisitorField('rut');
        this.validateVisitorField('email');
        this.validateVisitorField('phone');
        this.validateVisitorField('terms');
        // En modo "schedule" la pregunta de mudanza se hace en el paso 3 (profileForm), no aquí.
        const missingMovingTimeline = this.showMovingTimeline && this.form.movingTimeline === null;
        if (this.errors.name || this.errors.rut || this.errors.email || this.errors.phone || this.errors.terms || missingMovingTimeline) {
            return;
        }
        if (!this.canSubmitVisitorForm || this.sending) return;
        const hasPreselectedSlot = this.isSlotFirstFlow
            && !!this.scheduleVisitCalendar.selectedDate
            && !!this.scheduleVisitCalendar.selectedTime;
        this.sending = true;
        try {
            const unit = this.selectedUnit || this.cheapestUnitInTab;

            // Separar nombre completo en nombre y apellido
            const nameParts = (this.form.full_name || '').trim().split(/\s+/);
            const firstName  = nameParts[0] || '';
            const lastName   = nameParts.slice(1).join(' ') || firstName;

            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
            const url = `${globalThis.location.origin}/arriendo/departamento/im-interested`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    name: firstName,
                    last_name: lastName,
                    email: this.form.email,
                    code_phone: this.form.code_phone,
                    phone: this.form.phone,
                    unit_id: unit?.id,
                    rut: this.form.rut,
                    terms: this.form.terms ? '1' : '0',
                    moving_timeline: this.form.movingTimeline,
                    call_to_action: this.visitorFormMode === 'interest' ? 'portal.contactame' : 'portal.visita',
                    experiment_variant: this.calendarExperimentAssignment ?? null,
                     ...(this.isAuraReferral
                         ? { signatureHash: referral.signatureHash }
                         : { refer_code: referral.refer_code ?? window.referralCode?.getValue?.() ?? this.formDataContactme.refer_code ?? '' }),
                    fbclid: window.fbclid ? window.fbclid.getValue() : '',
                    gclid: window.gclid  ? window.gclid.getValue()  : '',
                    ...(window.utm ? (JSON.parse(window.utm.getValue() || 'null') || {}) : {}),
                }),
            });

            if(this.visitorFormMode === 'schedule') {
                if(globalThis.assetplanAnalytics){
                    globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:basic_info_form_submit', {
                        building_type: building.multifamily ? 'multifamily' : 'retail',
                    })
                }
            }

            if(this.visitorFormMode === 'interest') {
                if(globalThis.assetplanAnalytics){
                    globalThis.assetplanAnalytics.for('sitio_web').track('contact_form_submit')
                }
            }

            const data = await this.safeScheduleResponseJson(response);

            if (!response.ok) {
                if (data?.code === 'AURA_LEAD_INELIGIBLE') {
                    this.clearAuraReferralState(true);
                }
                this.triggerToast(
                    response.status === 419
                        ? 'Tu sesión expiró. Recarga la página e inténtalo nuevamente.'
                        : data?.message ?? 'Error al enviar el formulario.',
                    'error',
                );
                return;
            }

             this.form = adoptEffectiveRut(this.form, data);
             this.effectiveRut = this.form.rut;
             this.leadId = data.lead_id ?? null;
             this.brokerId = data.broker_id ?? null;
             this.scheduleUrl = data.schedule_url ?? null;
             this.scheduleUrlV1 = data.schedule_url_v1 ?? null;
             this.availabilityUrlV1 = data.availability_url_v1 ?? null;

             if (data.aura_referral_fallback || (this.isAuraReferral && !data.schedule_url)) {
                 this.clearAuraReferralState();
             }

             if (this.visitorFormMode === 'interest') {
                 const variant = this.calendarExperimentVariant ?? 'control';
                 // Flujo "me interesa": siempre va a success_with_schedule
                 // Si la unidad es visitable y mudanza próxima, precargar horarios (auto-selecciona primer día)
                 if (this.shouldOfferScheduling && data.schedule_url) {
                      await this.fetchAvailableTimeSlots(this.isAuraReferral ? null : data.lead_id, unit?.id, 1, null, {
                          variant,
                          ...(this.isAuraReferral && this.availabilityUrlV1 ? { auraAvailabilityUrl: this.availabilityUrlV1 } : {}),
                      });
                  }
                 await this.fetchSimilarBuildings();
                 this.clearVisitorFormAfterSuccess(true, true);
                 this.goTo('success_with_schedule');
            } else {
                const variant = this.calendarExperimentVariant ?? 'control';
                // Flujo "agendar visita": si la unidad es visitable, forza el paso de selección de fecha
                // (la fecha de mudanza se pregunta en el paso 3, igual que el componente schedule-visit).
                 if (data.is_visitable && hasPreselectedSlot) {
                    // HORARIO-VISIBLE: el horario ya se eligió en el Paso 1; se pasa directo a las preguntas.
                    this.goTo('schedule_confirmation');
                } else if (data.is_visitable) {
                     // Fetch interno independiente: el calendario de schedule_visit tiene su propio estado,
                     // sin copiar ni depender del calendario externo.
                     this.scheduleVisitCalendar.resetTimeSlots();
                     // Confirmación va a /schedule-visit (V1) desde submitScheduleConfirmation()
                     // (ver línea ~1336). Reutilizamos la variante efectiva para mantener
                     // consistente el contrato de availability y confirmación.
                       await this.scheduleVisitCalendar.fetchAvailableTimeSlots(this.isAuraReferral ? null : data.lead_id, unit?.id, 1, null, {
                          variant,
                          ...(this.isAuraReferral && this.availabilityUrlV1 ? { auraAvailabilityUrl: this.availabilityUrlV1 } : {}),
                      });
                    this.goTo('schedule_visit');
                } else {
                    await this.fetchSimilarBuildings();
                    this.goTo('schedule_success');
                }
            }
        } catch (err) {
            console.error('[submitVisitorForm]', err);
            this.triggerToast('Error al enviar el formulario.', 'error');
        } finally {
            this.sending = false;
        }
    },

    /**
     * Envía el perfil de arriendo (paso 3 schedule_confirmation).
     * Crea el ScheduleLead via POST /schedule-visit.
     */
    async submitScheduleConfirmation() {
        if (!this.canSubmitProfile || this.sending) return;
        // ponytail: guard against POST with null slot in horario-visible variant.
        // The inline calendar auto-selects the first day/slot, but if the user reaches
        // step 3 without a valid slot, abort and notify instead of sending null to the backend.
        if (!this.scheduleVisitCalendar.selectedDate || !this.scheduleVisitCalendar.selectedTime) {
            console.error('[submitScheduleConfirmation] sin slot preelegido', {
                selectedDate: this.scheduleVisitCalendar.selectedDate,
                selectedTime: this.scheduleVisitCalendar.selectedTime,
                variant: this.calendarExperimentVariant,
            });
            this.triggerToast('Por favor selecciona una fecha y hora antes de continuar.', 'error');
            this.goTo('schedule_visit');
            return;
        }
        this.sending = true;
        try {
            const unit = this.selectedUnit || this.cheapestUnitInTab;
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
             const isHorarioVisible = this.calendarExperimentVariant === 'horario-visible';
             const url = isHorarioVisible
                 ? this.scheduleUrl
                 : (this.isAuraReferral
                     ? this.scheduleUrlV1
                     : `${globalThis.location.origin}/arriendo/departamento/schedule-visit`);

             if (!url) {
                 this.triggerToast('La referencia de agendamiento ya no está disponible. Recarga la página para continuar.', 'error');
                 return;
             }

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                    'Accept': 'application/json',
                    ...(isHorarioVisible ? { 'Idempotency-Key': this.bookingKey } : {}),
                },
                body: JSON.stringify({
                     ...(isHorarioVisible ? {} : (this.isAuraReferral ? {} : { lead_id: this.leadId })),
                    unit_id:      unit?.id,
                    agenda_fecha: this.scheduleVisitCalendar.selectedDate,
                    agenda_hora:  this.scheduleVisitCalendar.selectedTime,
                    // has_guarantor is fixed at 1; this component has no guarantor input.
                    has_guarantor: 1,
                    has_income:    this.profileForm.hasIncome,
                    moving_timeline: this.effectiveMovingTimeline,
                }),
            });

            const data = await this.safeScheduleResponseJson(response);

            if (!response.ok) {
                this.triggerToast(
                    response.status === 419
                        ? 'Tu sesión expiró. Recarga la página e inténtalo nuevamente.'
                        : data?.message ?? 'Error al agendar la visita.',
                    'error',
                );
                if (response.status === 422) {
                    this.bookingIdempotencyKey = null;
                    // El horario dejó de estar disponible: volver a elegir con horarios frescos
                    // usando el calendario interno, no el externo.
                    await this.scheduleVisitCalendar.reloadTimeSlots();
                    this.goTo('schedule_visit');
                }
                return;
            }

            if (!(Number(data?.schedule_lead_id) > 0)) {
                this.triggerToast(data?.message ?? 'Error al agendar la visita.', 'error');
                return;
            }

            if (this.isAuraReferral && Number(data?.schedule_lead_id) > 0) {
                this.clearAuraReferralState(true, true);
            }
            this.clearVisitorFormAfterSuccess();
            if (isHorarioVisible && Number(data?.schedule_lead_id) > 0) {
                this.bookingIdempotencyKey = null;
            }
            await this.fetchSimilarBuildings();

            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:requirements_info_submit', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                })
            }

            this.goTo('schedule_success');
        } catch (err) {
            console.error('[submitScheduleConfirmation]', err);
            this.triggerToast('Error al agendar la visita.', 'error');
        } finally {
            this.sending = false;
        }
    },

    clearAuraReferralState(clearScheduleUrl = false, clearGlobalPayload = false) {
        referral.signatureHash = '';
        referral.referral_eligible = false;
        globalThis.__auraReferralPayload = clearGlobalPayload ? null : referral;
        this.scheduleUrlV1 = null;
        this.availabilityUrlV1 = null;
        if (clearScheduleUrl) this.scheduleUrl = null;
        this.removeAuraSignatureHashFromUrl();
    },
    clearVisitorFormAfterSuccess(preserveMovingTimeline = false, preserveLeadId = false) {
        const movingTimeline = this.form?.movingTimeline ?? null;
        const leadId = this.leadId;
        this.clearVisitorFormState({ preserveMovingTimeline, movingTimeline, preserveLeadId, leadId });
        clearAuraReferralPayload(referral, { source: 'building-page' });
    },
    clearVisitorFormState({ preserveMovingTimeline = false, movingTimeline = null, preserveLeadId = false, leadId = null } = {}) {
        this.effectiveRut = '';
        this.leadId = preserveLeadId ? (leadId ?? this.leadId) : null;
        this.form = {
            ...this.form,
            name: '',
            first_name: '',
            last_name: '',
            full_name: '',
            rut: '',
            email: '',
            code_phone: '56',
            phone: '',
            terms: false,
            movingTimeline: preserveMovingTimeline ? (movingTimeline ?? this.form?.movingTimeline ?? null) : null,
        };
    },
    removeAuraSignatureHashFromUrl() {
        const url = new URL(globalThis.location.href);
        if (!url.searchParams.has('signatureHash')) return;
        url.searchParams.delete('signatureHash');
        globalThis.history.replaceState(globalThis.history.state, '', url.pathname + url.search + url.hash);
    },

    async safeScheduleResponseJson(response) {
        const contentType = response.headers?.get?.('content-type') ?? '';
        if (contentType && !contentType.toLowerCase().includes('json')) return {};

        try {
            return await response.json();
        } catch {
            return {};
        }
    },

    async fetchSimilarBuildings() {
        const unit = this.selectedUnit || this.cheapestUnitInTab;
        const communeId = unit?.commune_id 
            ?? unit?.building?.commune_id 
            ?? unit?.building?.comuna_id 
            ?? unit?.comuna_id 
            ?? this.building?.commune_id 
            ?? this.building?.comuna_id;
        const buildingId = unit?.building_id 
            ?? unit?.building?.building_id 
            ?? unit?.building?.id 
            ?? this.building?.building_id 
            ?? this.building?.id;

        if (!communeId) return;
        try {
            const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';
            const response = await fetch('/api/buildings/search-by-commune', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ commune_id: communeId, limit: 6 }),
            });
            if (!response.ok) return;
            const data = await response.json();
            const buildings = data.data?.buildings || data.buildings || [];
            this.similarBuildings = buildings
                .filter(b => (b.building_id ?? b.id) !== buildingId)
                .slice(0, 4);
        } catch (err) {
            console.error('[fetchSimilarBuildings] error:', err);
        }
    },

    slug(text) {
        if (!text) return '';
        let str = text.name ?? text.nombre ?? text;
        return str.toString().toLowerCase().trim().normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '').replace(/ñ/g, 'n')
            .replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
    },

    async getQuote() {
        if (!this.quoteParams.unit_id) return;

        this.isLoadingQuote = true;
        const endpoint = this.quotationPreviewUrl;

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(this.quoteParams)
            });

            if (!response.ok) throw new Error('Error en la petición');

            const data = await response.json();

            if (data.status === 'success') {
                this.quote = data.quote;
            }

        } catch (error) {
            console.error('Error obteniendo cotización:', error);
        } finally {
            this.isLoadingQuote = false;
        }
    },

    loadMap(container, time) {
        setTimeout(() => {
            if (typeof Mapbox === 'undefined') {
                console.warn('Mapbox aún no está disponible, reintentando...');
                setTimeout(() => this.loadMap(container, time), 100);
                return;
            }

            const [lat, lng] = this.building.latlng.split(',').map(coord => parseFloat(coord.trim()));

            Mapbox.makeMap(container, {
                zoom: 15,
                center: [lng, lat],
                minZoom: 11,
                maxZoom: 17,
                interactive: false
            },
            {
                showZoom: false
            });

            Mapbox.addMarker({
                center: [lng, lat]
            });

            Mapbox.resize();
        }, time);
    }, 
    
    async setActiveTab(slug) {
        this.isLoadingModels = true;
        if (this.activeTab !== slug) this.showInlineCalendar = false;
        if (this.activeTab !== slug) this.mobileAgendaSheetOpen = false;
        this.activeTab = slug;
        this.processedModels = [];

        // Resetear selección de unidad y horarios al cambiar de tab para evitar
        // estado inconsistente (CTA stale, fecha/hora de otra tipología).
        this.selectedUnit = null;
        this.selectedDate = null;
        this.selectedTime = null;

        // El loading del TAB termina cuando los modelos del nuevo tab están listos.
        // La disponibilidad del calendario tiene su propio ciclo async y ya no
        // debe bloquear el loading visual del cambio de tab.
        // try/finally: si algo lanza, isLoadingModels igual se apaga y los CTAs vuelven a mostrarse.
        try {
            this.updateBuildingPrices(slug);
            this.scrollToSection(slug);
            this.updateUrl(slug);

            await this.fetchModels(slug);

            this.updateCurrentGroups(slug);
            this.updateCurrentModels(slug);
        } finally {
            this.isLoadingModels = false;
        }

        await this.initCalendarSlots();

        // Re-evaluar exposure del experimento tras cargar la nueva tipología.
        // Si typologyIsVisitable es true, ensureCalendarExperimentExposure() dispara
        // native exposure (send_event:true → $feature_flag_called) y custom exposure
        // de forma idempotente.
        this.ensureCalendarExperimentExposure({ isMultifamily: true });
    },

    async fetchModels(slug) {
        if (!slug) return;
        try {
            const response = await fetch(`/arriendo/departamento/buildings/${this.building.id}/models/${slug}`);
            if (response.ok) {
                const data = await response.json();

                // Extraer modelos y convertirlos a objeto indexado por ID/nombre para compatibilidad
                const models = {};
                if (data.models && Array.isArray(data.models)) {
                    data.models.forEach(m => {
                        const key = m.id_plano || m.plano_table_tipologias_id || m.nombre || Math.random().toString();
                        models[key] = m;
                    });
                } else if (data.models) {
                    // Si ya es un objeto, usarlo directamente
                    Object.assign(models, data.models);
                }

                //sort by unidades desc
                const planosOrdenados = Object.entries(models)
                .sort((a, b) => b[1].unidades.length - a[1].unidades.length)
                .map(([id, plano]) => ({ id, ...plano }));

                this.allGroupedUnits[slug] = planosOrdenados;
                if (!this.originalGroupedUnits[slug]) {
                    this.originalGroupedUnits[slug] = JSON.parse(JSON.stringify(planosOrdenados));
                }

                // Actualizar información global de super promo del edificio
                if (data.super_promo !== undefined) {
                    this.building.super_promo = data.super_promo;
                    this.building.benefits_promo = data.benefits_promo;
                    this.building.flex = data.flex;
                    this.building.badges = data.badges;
                }

                // El requisito de renta depende de la regla de aval de cada unidad. A nivel
                // edificio solo se muestra si todas las unidades comparten el mismo texto;
                // si difieren, la vista pide elegir una unidad en vez de mostrar uno cualquiera.
                const incomeRequirements = [...new Set(planosOrdenados
                    .flatMap(plano => plano.unidades)
                    .map(unidad => unidad?.income_requirement)
                    .filter(Boolean))];

                this.building.income_requirement = incomeRequirements.length === 1 ? incomeRequirements[0] : null;
            }
        } catch (e) {
            console.error('Error fetching models:', e);
        }
    },

    updateBuildingPrices(slug) {
        if (!this.building.available_typologies_tabs) return;
        const typology = this.building.available_typologies_tabs.find(t => t.slug === slug);
        if (typology) {
            this.building.min_price = typology.min_price;
            this.building.min_ggcc_fijo = typology.min_ggcc;
            this.building.has_discount = typology.has_discount ? 1 : 0;
        }
    },

    updateUrl(slug) {
        const currentUrl = new URL(window.location.href);
        const pathSegments = currentUrl.pathname.split('/');

        // La URL es /arriendo/departamento/{building_id}/{building_name}/{typology}
        if (pathSegments.length >= 7) {
            pathSegments[6] = slug;
            currentUrl.pathname = pathSegments.join('/');

            // Al cambiar de tipología, removemos el unit_id de los query params
            currentUrl.searchParams.delete('unit_id');

            // El cambio de pathname dispara el $pageview automático de PostHog
            pageviewContext.merge({ typology: slug, unit_id: null });

            // Usar replaceState para no acumular entradas en el historial
            window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);
        }
    },

    // Devuelve la URL completa de una tipología para usarla en <a href>.
    // Permite que los crawlers descubran las URLs de tipología como links internos
    // sin depender de window.open() ni replaceState().
    getBuildingTypologyUrl(slug) {
        const currentUrl = new URL(window.location.href);
        const pathSegments = currentUrl.pathname.split('/');
        if (pathSegments.length >= 7) {
            const newSegments = [...pathSegments];
            newSegments[6] = slug;
            return newSegments.join('/');
        }
        return currentUrl.pathname;
    },

    updateUrlUnit(unitId) {
        const currentUrl = new URL(window.location.href);
        const previousUnitId = currentUrl.searchParams.get('unit_id');

        if (unitId) {
            currentUrl.searchParams.set('unit_id', unitId);
        } else {
            currentUrl.searchParams.delete('unit_id');
        }


        // Usar replaceState para no acumular entradas en el historial del navegador
        window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);

        // Cambiar sólo ?unit_id= no dispara el $pageview automático (history_change
        // mira el pathname), así que se emite a mano al seleccionar una unidad.
        // Al deseleccionar sólo se limpia el contexto, sin emitir.
        const nextUnitId = currentUrl.searchParams.get('unit_id');
        if (nextUnitId !== previousUnitId) {
            pageviewContext.merge({ unit_id: nextUnitId === null ? null : Number(nextUnitId) });

            if (nextUnitId !== null) {
                pageviewContext.capturePageview();
            }
        }
    },

    ensureTypologyInUrl() {
        const currentUrl = new URL(window.location.href);
        const pathSegments = currentUrl.pathname.split('/');

        // La URL es /arriendo/departamento/{commune}/{building_id}/{building_name}/{typology}
        // Si no hay tipología en la posición 4 o está vacía, agregar 'estudio'
        if (pathSegments.length < 7 || !pathSegments[6] || pathSegments[6].trim() === '') {
            // Usar la primera tipología disponible o 'estudio' por defecto
            const defaultTypology = this.getDefaultTypology();
            pathSegments[6] = defaultTypology;

            // Reconstruir la URL completa
            currentUrl.pathname = pathSegments.join('/');

            // El cambio de pathname dispara el $pageview automático de PostHog
            pageviewContext.merge({ typology: defaultTypology });

            // Reemplazar la URL actual sin agregar entrada al historial
            window.history.replaceState({ path: currentUrl.href }, '', currentUrl.href);

            // Actualizar el activeTab para reflejar la tipología seleccionada
            this.activeTab = defaultTypology;

            // Actualizar grupos, modelos y precios para la nueva tipología
            this.updateCurrentGroups(defaultTypology);
            this.updateCurrentModels(defaultTypology);
            this.updateBuildingPrices(defaultTypology);

            console.log(`Tipología añadida automáticamente a la URL: ${defaultTypology}`);
        }
    },

    getDefaultTypology() {
        // Verificar si hay tipologías disponibles y usar la primera según el orden establecido
        if (this.tabs && this.tabs.length > 0) {
            // Si no se encuentra ninguna de las tipologías del orden, usar la primera disponible
            return this.tabs[0].slug;
        }
        // Fallback a 'estudio' si no hay tipologías disponibles
        return 'estudio';
    },
    async fetchUnitById(unitId) {
        try {
            const response = await fetch(`/arriendo/departamento/units/${unitId}`);
            if (!response.ok) {
                return null;
            }
            const unit = await response.json();
            return unit;
        } catch (error) {
            console.error("Error fetching unit by ID:", error);
            return null;
        }
    },
    async checkUrlForUnit() {
        const params = new URLSearchParams(window.location.search);
        const unitId = parseInt(params.get('unit_id') ?? params.get('selectedUnit'));

        if (unitId && !isNaN(unitId)) {
            try {
                // Llamar al endpoint para obtener la unidad
                const response = await fetch(`/arriendo/departamento/units/${unitId}`);

                // Caso: Unidad no encontrada (404)
                if (!response.ok) {
                    await this.handleUnitNotFound(unitId);
                    return;
                }

                const unit = await response.json();

                if (unit) {
                    // Encontrar modelo y slug
                    let foundSlug = null;
                    let foundModelName = null;
                    let foundModelData = null;
                    
                    // OD: Ensure we have the models for this unit's typology
                    const typologyName = unit.typology?.tipologia || unit.tipologia;
                    const bedrooms = unit.typology?.bedrooms ?? unit.bedrooms;
                    
                    let targetSlug = null;
                    if (typologyName === 'Estudio') targetSlug = 'estudio';
                    else if (bedrooms === 1) targetSlug = '1-dormitorio';
                    else if (bedrooms === 2) targetSlug = '2-dormitorios';
                    else if (bedrooms === 3) targetSlug = '3-dormitorios';
                    else if (bedrooms >= 4) targetSlug = '4-o-mas-dormitorios';
                    
                    if (targetSlug && (!this.allGroupedUnits[targetSlug] || Object.keys(this.allGroupedUnits[targetSlug]).length === 0)) {
                         await this.fetchModels(targetSlug);
                    }

                    // Buscar en originalGroupedUnits usando plano_tipo_id si está disponible, o iterando
                    // We must use allGroupedUnits as it is now populated
                    const sourceGrouped = this.allGroupedUnits;

                    // Estrategia 1: Usar plano_tipo_id si viene en la unidad
                    if (unit.plano_tipo_id) {
                         for (const [slug, models] of Object.entries(sourceGrouped)) {
                            for (const [modelName, modelData] of Object.entries(models)) {
                                if (modelData.id_plano === unit.plano_tipo_id) {
                                    foundSlug = slug;
                                    foundModelName = modelName;
                                    foundModelData = modelData;
                                    break;
                                }
                            }
                            if (foundSlug) break;
                        }
                    }

                    // Estrategia 2: Si no se encontró por ID de plano (o no venía), buscar si la unidad ya estaba en la data local (fallback)
                    if (!foundSlug) {
                         for (const [slug, models] of Object.entries(sourceGrouped)) {
                            for (const [modelName, modelData] of Object.entries(models)) {
                                if (modelData.unidades && modelData.unidades.some(u => u.id === unit.id)) {
                                    foundSlug = slug;
                                    foundModelName = modelName;
                                    foundModelData = modelData;
                                    break;
                                }
                            }
                            if (foundSlug) break;
                        }
                    }

                    if (foundSlug) {
                        // Cambiar tab si es necesario
                        if (this.activeTab !== foundSlug) {
                            this.setActiveTab(foundSlug);
                        }

                        // Preparar selectedModel minimal para el detalle inmediato
                        const modelInfo = this.getModelInfo(foundModelName, foundModelData);
                        const idPlano = foundModelData.id_plano ? foundModelData.id_plano : foundModelData.plano_table_tipologias_id;
                        const hasIdPlano = !!foundModelData.id_plano;

                        this.selectedModel = {
                            name: modelInfo.title,
                            img: modelInfo.img,
                            id_plano: idPlano,
                            has_id_plano: hasIdPlano,
                            units: foundModelData.unidades || [],
                            availableUnitsList: (foundModelData.unidades || []).filter(u => u.is_visitable),
                            unavailableUnitsList: (foundModelData.unidades || []).filter(u => !u.is_visitable),
                            availableUnits: (foundModelData.unidades || []).filter(u => u.is_available).length
                        };

                        // Configurar navegación inmediata para evitar saltos
                        this.selectedUnit = unit;
                        this.step = 'detail';
                        this.history = ['list'];
                        this.isLoadingUnitDetail = true;
                        this.openDrawerUnits = true;

                        if (params.get('agendar') === '1' && unit.is_visitable) {
                            this.$nextTick(() => {
                                this.visitorFormMode = 'schedule';
                                this.goTo('visitor_form');
                            });
                        }

                        try {
                             // Fetch de todas las unidades del modelo de forma asíncrona pero sin bloquear la vista de detalle
                            let url = `/arriendo/departamento/buildings/${this.building.id}/units?`;
                            if (hasIdPlano) {
                                url += `plano_id=${idPlano}`;
                            } else {
                                url += `typology_id=${idPlano}`;
                            }
                            const unitsResponse = await fetch(url);
                            let freshUnits = [];

                            if (unitsResponse.ok) {
                                freshUnits = await unitsResponse.json();
                            } else {
                                freshUnits = [unit];
                            }

                            // Filtrar unidades respetando filtros
                            let filteredFreshUnits = freshUnits.filter(u => this.unitMatchesFilters(u));

                            // Asegurar que la unidad seleccionada esté presente
                            if (!filteredFreshUnits.some(u => u.id === unit.id)) {
                                filteredFreshUnits.push(unit);
                            }

                            const available = filteredFreshUnits.filter(u => u.is_visitable);
                            const unavailable = filteredFreshUnits.filter(u => !u.is_visitable);

                            // Caso: La unidad existe pero NO está disponible
                            if (!unit.is_available && !unit.is_visitable) {
                                this.openDrawerUnits = false;
                                await this.handleUnitNotAvailable(unit, foundModelData, modelInfo, available, unavailable);
                                return;
                            }

                            // Actualizar selectedModel con data fresca
                            this.selectedModel.units = filteredFreshUnits;
                            this.selectedModel.availableUnitsList = available;
                            this.selectedModel.unavailableUnitsList = unavailable;
                            this.selectedModel.availableUnits = available.length;

                            // Refrescar también la unidad para obtener detalles completos (si faltan)
                            const fullUnit = await this.fetchUnitById(unit.id);
                            if (fullUnit) {
                                this.selectedUnit = fullUnit;

                                if (params.get('video') === '1' && this.selectedUnit.url_videos?.length > 0) {
                                    this.tabSelectedGallery = 'videos';
                                    this.goTo('unit_photos');
                                }
                            }

                        } catch (e) {
                            console.error("Error cargando data adicional para la unidad", e);
                        } finally {
                            this.isLoadingUnitDetail = false;
                        }

                        // Call site 3: selectedUnit quedó asignada y fetchModels(targetSlug) si fue necesario ya resolvió.
                        // Este es el punto de entrada para navegación directa a unidad (Landing MF / Retail).
                        this.trackExperimentExposureIfEligible();
                    } else {
                        // No se encontró el modelo en los datos locales
                        await this.handleUnitNotFound(unitId, unit);
                    }
                }
            } catch (error) {
                console.error("Error al cargar la unidad desde URL:", error);
                await this.handleUnitNotFound(unitId);
            }
        }
    },

    /**
     * Manejar caso cuando la unidad no se encuentra (404 o no existe en el edificio)
     */
    async handleUnitNotFound(unitId, unitData = null) {
        // Limpiar el unit_id de la URL ya que no es válido
        this.updateUrlUnit(null);

        // Obtener unidades del tamaño/tipología seleccionada actualmente
        if (!this.allGroupedUnits[this.activeTab] || Object.keys(this.allGroupedUnits[this.activeTab]).length === 0) {
            try {
                await this.fetchModels(this.activeTab);
            } catch (e) {
                console.error("Error fetching models for fallback:", e);
            }
        }

        const currentSlugModels = this.allGroupedUnits[this.activeTab] || {};
        let unitsFromCurrentTab = [];

        // Extraer todas las unidades de los modelos del tab activo
        for (const [modelName, modelData] of Object.entries(currentSlugModels)) {
            if (modelData.unidades) {
                unitsFromCurrentTab = unitsFromCurrentTab.concat(modelData.unidades);
            }
        }

        const available = unitsFromCurrentTab.filter(u => [8, 9, 12].includes(u.estado_vacios));
        const unavailable = unitsFromCurrentTab.filter(u => ![8, 9, 12].includes(u.estado_vacios));

        // Buscar si la unidad está en las no disponibles para obtener su información
        const foundInUnavailable = unavailable.find(u => u.id === unitId);

        // Determinar la información de la unidad
        let unitName = unitData?.unidad || unitData?.nombre || `Unidad ${unitId}`;
        let reason = 'not_found';
        let unitBathrooms = null;
        let unitM2 = null;
        let unitM2Terrace = null;
        let unitFloor = null;

        if (foundInUnavailable) {
            unitName = foundInUnavailable.unidad || foundInUnavailable.nombre || unitName;
            unitBathrooms = foundInUnavailable.typology?.bathrooms || foundInUnavailable.bathrooms || null;
            unitM2 = foundInUnavailable.m2_utiles || null;
            unitM2Terrace = foundInUnavailable.m2_terraza || 0;
            unitFloor = foundInUnavailable.piso || null;
            reason = 'not_available';
        }

        // Obtener label de la tipología actual
        const currentTabLabel = this.labels[this.activeTab] || this.activeTab;

        this.notFoundUnitData = {
            unitId: unitId,
            unitName: unitName,
            unitBathrooms: unitBathrooms,
            unitM2: unitM2,
            unitM2Terrace: unitM2Terrace,
            unitFloor: unitFloor,
            reason: reason,
            availableUnits: available,
            unavailableUnits: unavailable,
            buildingName: this.building.name,
            buildingPhoto: this.building.photos?.[0] || '/img/image/edificio.png',
            typologyLabel: currentTabLabel
        };

        this.openDrawerUnitNotFound = true;
    },

    /**
     * Manejar caso cuando la unidad existe pero no está disponible
     */
    async handleUnitNotAvailable(unit, modelData, modelInfo, available, unavailable) {
        this.isLoadingUnits = false;

        this.notFoundUnitData = {
            unitId: unit.id,
            unitName: unit.unidad || unit.nombre,
            reason: 'not_available',
            modelName: modelInfo.title,
            modelImg: modelInfo.img,
            availableUnits: available,
            unavailableUnits: unavailable,
            buildingName: this.building.name,
            buildingPhoto: this.building.photos?.[0] || '/img/image/edificio.png',
            typologyBedrooms: modelData?.plano_typology?.bedrooms || null
        };

        this.openDrawerUnitNotFound = true;
    },

    /**
     * Cerrar el drawer de unidad no encontrada
     */
    closeDrawerUnitNotFound() {
        this.openDrawerUnitNotFound = false;
        this.notFoundUnitData = null;
    },

    /**
     * Seleccionar una unidad desde el drawer de no encontrada
     */
    selectUnitFromNotFound(unit) {
        this.closeDrawerUnitNotFound();

        // Actualizar URL con la nueva unidad
        this.updateUrlUnit(unit.id);

        // Recargar con la nueva unidad
        this.$nextTick(() => {
            this.checkUrlForUnit();
        });
    },

    updateCurrentGroups(slug) {
        const tab = this.tabs.find(t => t.slug === slug); 
        if (!tab) {
            this.currentGroups = {};
            return;
        } 
        this.currentGroups = this.allGroupedUnits[slug] ?? {};
    },
    
    updateCurrentModels(slug) {
        this.currentModels = this.allGroupedUnits[slug] ?? {};
        
        // Procesar modelos con su información asegurando que usemos el nombre del modelo contenido en la data
        this.processedModels = Object.entries(this.currentModels).map(([key, modelData]) => {
            const modelName = modelData.nombre || key;
            const modelId = modelData.id_plano || modelData.id || key;
            return {
                id: modelId,
                name: modelName,
                data: modelData,
                info: this.getModelInfo(modelName, modelData)
            };
        });
         
    },
    
    getModelInfo(modelName, modelData) {
        const unidades = modelData.unidades || [];
        const availableUnits = unidades.filter(unit => [8, 9, 12].includes(unit.estado_vacios)).length;
        const availabilityForCoordinateVisit = unidades.filter(unit => [8].includes(unit.estado_vacios)).length;

        // Obtener el precio más bajo de las unidades disponibles
        const prices = unidades
            .filter(unit => [8, 9, 12].includes(unit.estado_vacios) && unit.price)
            .map(unit => parseFloat(unit.price.monto_depto));
        
        const minPrice = prices.length > 0 ? Math.min(...prices) : 0;
        
        // Construir título del modelo usando el nombre real de la data
        const tipologia = modelData.plano_typology || modelData.typology;
        if (!tipologia) return { title: modelName, availability: 0 };

        const banios = (modelData.id_plano || modelData.plano_table_tipologias_id) ? `${tipologia.bathrooms} ${tipologia.bathrooms === 1 ? 'baño' : 'baños'}` : null;

        // Obtener m² promedio
        const m2 = unidades.length > 0 ? parseFloat(unidades[0].m2_utiles || 0) : 0;
        const m2Text = m2 > 0 ? `${Math.round(m2)} m²` : '';
        
        // Verificar si tiene terraza
        const hasTerraza = unidades.some(unit => parseFloat(unit.m2_terraza || 0) > 0);
        const terrazaText = hasTerraza ? 'Terraza' : '';
        
        // CONSTRUYO EL TÍTULO CON EL NOMBRE REAL DEL MODELO
        const nameToUse = modelData.nombre || modelName;
        const titleParts = [
            `${nameToUse}`,
            banios,
            m2Text,
            terrazaText
        ].filter(Boolean);
        
        const benefitsPromo = modelData.benefits_promo ?? null;
        const result = {
            title: titleParts.join(' · '),
            availability: availableUnits,
            availabilityForCoordinateVisit: availabilityForCoordinateVisit,
            price: minPrice > 0 ? `${this.formatPrice(minPrice)}` : '',
            badge: this.getModelBadge(modelData),
            img: modelData.plano_url_imagen || '/img/anuncio/sin-modelo.svg',
            bedrooms: tipologia.bedrooms,
            super_promo: modelData.super_promo ?? false,
            benefits_promo: benefitsPromo,
            has_any_promo_benefit: benefitsPromo
                ? Object.values(benefitsPromo).filter(b => b.show).length > 1
                : false,
        };
        
        return result;
    },
    
    getModelBadge(modelData) {
        const unidades = modelData.unidades || [];
        const hasDiscount = unidades.some(unit => 
            unit.price && parseFloat(unit.price.porcentaje_descuento) > 0
        );
        
        return hasDiscount ? 'Meses OFF' : null;
    },  

    async openModelDrawer(model) {
        // Feedback visual inmediato
        this.isNavigating = true;

        // Resetear el estado del drawer al abrir
        this.step = 'list';
        this.history = [];
        this.selectedUnit = null;

        const idPlano = model.data.id_plano ? model.data.id_plano : model.data.plano_table_tipologias_id;
        const hasIdPlano = !!model.data.id_plano;

        this.selectedModel = {
            name: model.info.title, 
            img: model.info.img, 
            id_plano: idPlano,
            has_id_plano: hasIdPlano,
            units: [],
            availableUnits: 0 
        };

        this.isLoadingUnits = true;
        this.openDrawerUnits = true;

        try {
            let url = `/arriendo/departamento/buildings/${this.building.id}/units?`;
            if (model.data.id_plano) {
                url += `plano_id=${model.data.id_plano}`;
            } else {
                url += `typology_id=${model.data.plano_table_tipologias_id}`;
            }

            const response = await fetch(url);
            if (!response.ok) throw new Error('Error en la carga');

            const freshUnits = await response.json();

            // Filtrar las unidades frescas usando los filtros aplicados
            const filteredFreshUnits = freshUnits.filter(u => this.unitMatchesFilters(u));
            const available = filteredFreshUnits.filter(u => u.is_visitable);
            const unavailable = filteredFreshUnits.filter(u => !u.is_visitable);

            // Actualizamos el modelo con data fresca de la base de datos
            this.selectedModel.units = filteredFreshUnits;
            this.selectedModel.availableUnitsList = available;
            this.selectedModel.unavailableUnitsList = unavailable;
            this.selectedModel.availableUnits = available.length;

            if (this.selectedModel.availableUnits === 0) {
                console.warn('No hay unidades disponibles para este modelo.');
            }

        } catch (error) {
            console.error("No se pudo actualizar la disponibilidad:", error);
        } finally {
            this.isLoadingUnits = false;
            this.isNavigating = false;

            if (globalThis.assetplanAnalytics) {
                globalThis.assetplanAnalytics.for('sitio_web').track('model_select', {
                    building: this.building.name
                });
            }
        }
    },

    getOrientationText(orientacion) { ;
        const orientationKey = orientacion; 
       
        if (!orientationKey) {
            return 'Consultar';
        } 
        
        const translatedText = this.orientationsMap[orientationKey.toUpperCase()]; 
    
        return translatedText ?? orientationKey;
    },

    async getUnit(unit){
        // Asignar inmediatamente los datos que ya tenemos para evitar el parpadeo de datos vacíos
        this.selectedUnit = unit;
        this.showInlineCalendar = false;
        this.mobileAgendaSheetOpen = false;
        this.isLoadingUnitDetail = true;

        const fullUnit = await this.fetchUnitById(unit.id);
        if (fullUnit) {
            this.selectedUnit = fullUnit;
        }

        if (!this.canScheduleVisit) {
            this.showInlineCalendar = false;
            this.mobileAgendaSheetOpen = false;
        }

        this.isLoadingUnitDetail = false;

        // Agregar haptic feedback visual inmediato
        if (navigator.vibrate) {
            navigator.vibrate(50); // Vibración suave en dispositivos móviles
        }

        // Esto maneja el caso donde se selecciona una unidad antes de navegar a detail
        if (this.openDrawerUnits) {
            this.$nextTick(() => {
                this.updateUrlUnit(unit.id);
            });
        }
    },
   
    async refreshModelUnits(showLoading = false) {
        if (!this.selectedModel || !this.selectedModel.id_plano) return;

        if (showLoading) this.isLoadingUnits = true;

        try {
            let url = `/arriendo/departamento/buildings/${this.building.id}/units?`;
            
            if (this.selectedModel.has_id_plano) {
                url += `plano_id=${this.selectedModel.id_plano}`;
            } else {
                url += `typology_id=${this.selectedModel.id_plano}`;
            }

            const response = await fetch(url);
            if (response.ok) {
                const freshUnits = await response.json();
                const filteredFreshUnits = freshUnits.filter(u => this.unitMatchesFilters(u));

                this.selectedModel.units = filteredFreshUnits;
                this.selectedModel.availableUnitsList = filteredFreshUnits.filter(u => u.is_visitable);
                this.selectedModel.unavailableUnitsList = filteredFreshUnits.filter(u => !u.is_visitable);
                this.selectedModel.availableUnits = this.selectedModel.availableUnitsList.length;
            }
        } catch (error) {
            console.error("Error al refrescar unidades:", error);
        } finally {
            if (showLoading) this.isLoadingUnits = false;
        }
    },

    isActive(slug) {
        return this.activeTab === slug;
    },
    
    formatPrice(value) {
        const number = value ?? 0;
        return new Intl.NumberFormat("es-CL", {currency: 'CLP', style: 'currency'}).format(number);
    },

    // Etiqueta, tooltip y regla del total salen de CommonExpenseTypeEnum vía
    // BuildingResource (`building.ggcc`), para no repetir los textos en JS.
    ggccLabel() {
        return this.building?.ggcc?.label ?? 'Gasto común';
    },

    ggccTooltip() {
        return this.building?.ggcc?.tooltip ?? null;
    },

    ggccIncludedInTotal() {
        return this.building?.ggcc?.included_in_total ?? true;
    },

    monthlyTotalLabel() {
        return this.building?.ggcc?.monthly_total_label ?? 'Total mensual';
    },

    monthlyTotalNote() {
        return this.building?.ggcc?.monthly_total_note ?? null;
    },

    formatPorcentage(value) { 
        value = Math.round(value);
        return `${value}%`;
    },

    getUnitBadges(unit) {
        if (unit?.ordered_badges) {
            return [
                ...(unit.ordered_badges.promotions ?? []),
                ...(unit.ordered_badges.zone_features ?? []),
            ];
        }
        // Fallback: badges del edificio inyectados desde Blade
        return this.buildingBadges ?? [];
    },

    getBadgeColorClass(color) {
        const colorMap = {
            'gray':           'bg-gray-100 text-gray-600',
            'blue':           'bg-blue-100 text-blue-600',
            'green':          'bg-green-100 text-green-600',
            'red':            'bg-red-100 text-red-600',
            'yellow':         'bg-yellow-100 text-yellow-600',
            'orange':         'bg-orange-100 text-orange-600',
            'purple':         'bg-purple-100 text-purple-600',
            'white':          'bg-white text-gray-800',
            'super-promo':    'text-white bg-magentapromo-700',
            'inverted-green': 'text-green-100 bg-green-600',
            'inverted-blue':  'text-blue-100 bg-blue-600',
        };
        return colorMap[color] ?? colorMap['gray'];
    },

    sortTypologies(tabs) {
        return [...tabs].sort((a, b) => {
            const orderA = this.typologyOrder.indexOf(a.slug);
            const orderB = this.typologyOrder.indexOf(b.slug); 
         
            return (orderA === -1 ? 999 : orderA) - (orderB === -1 ? 999 : orderB);
        });
    }, 
    
    scrollToSection(id) {
        this.active = id;
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } 
    },
    
    handleScroll() {
        for (let tab of this.tabs) {
            const section = document.getElementById(tab.id);
            if (!section) continue;

            const rect = section.getBoundingClientRect();
            if (rect.top <= 100 && rect.bottom >= 100) {
                this.active = tab.id;
            }
        }
    },

    formatDistance(meters) {
        if (!meters) return '';
        if (meters < 1000) {
            return `${Math.round(meters)} metros`;
        }
        return `${(meters / 1000).toFixed(1)} km`;
    },

    formatWalkingTime(meters) {
        // Velocidad promedio de caminata: 80 metros por minuto
        const minutes = Math.round(meters / 80);
        return `${minutes} minuto${minutes !== 1 ? 's' : ''} caminando`;
    },

    translateType(type, count = 1) {
        const translations = {
            // Transporte
            'metro_station': count === 1 ? 'estación de Metro' : 'estaciones de Metro',
            'subway_station': count === 1 ? 'estación de Metro' : 'estaciones de Metro',
            'bus_stop': count === 1 ? 'paradero' : 'paraderos',
            'transit_station': count === 1 ? 'estación de transporte' : 'estaciones de transporte',
            'bus_station': count === 1 ? 'terminal de buses' : 'terminales de buses',
            'train_station': count === 1 ? 'estación de tren' : 'estaciones de tren',

            // Educación
            'university': count === 1 ? 'universidad' : 'universidades',
            'school': count === 1 ? 'colegio' : 'colegios',
            'secondary_school': count === 1 ? 'liceo' : 'liceos',
            'primary_school': count === 1 ? 'escuela' : 'escuelas',
            'kindergarten': count === 1 ? 'jardín infantil' : 'jardines infantiles',
            'preschool': count === 1 ? 'jardín' : 'jardines',

            // Salud
            'hospital': count === 1 ? 'hospital' : 'hospitales',
            'clinic': count === 1 ? 'clínica' : 'clínicas',
            'doctor': count === 1 ? 'centro médico' : 'centros médicos',
            'pharmacy': count === 1 ? 'farmacia' : 'farmacias',
            'health_center': count === 1 ? 'centro de salud' : 'centros de salud',
            'veterinary_care': count === 1 ? 'veterinaria' : 'veterinarias',
            'dentist': count === 1 ? 'dentista' : 'dentistas',
        };

        return translations[type] || type;
    },

    groupPlacesByType(places) {
        if (!places || places.length === 0) return {};

        const grouped = {};
        places.forEach(place => {
            const type = place.type || place.category || 'Otro';
            if (!grouped[type]) {
                grouped[type] = [];
            }
            grouped[type].push(place);
        });

        return grouped;
    },

    /**
     * Cargar filtros desde la URL
     */
    loadFiltersFromUrl() {
        const params = new URLSearchParams(window.location.search);

        // Cargar bedrooms
        const bedrooms = params.get('bedrooms');
        if (bedrooms) {
            this.appliedFilters.bedrooms = bedrooms.split(',').map(b => parseInt(b));
        }

        // Cargar bathrooms
        const bathrooms = params.get('bathrooms');
        if (bathrooms) {
            this.appliedFilters.bathrooms = bathrooms.split(',').map(b => parseInt(b));
        }

        // Cargar min_price
        const minPrice = params.get('min_price');
        if (minPrice) {
            this.appliedFilters.min_price = parseInt(minPrice);
        }

        // Cargar max_price
        const maxPrice = params.get('max_price');
        if (maxPrice) {
            this.appliedFilters.max_price = parseInt(maxPrice);
        }
    },

    /**
     * Verificar si una unidad cumple con los filtros
     */
    unitMatchesFilters(unit) {
        // Filtro de dormitorios
        if (this.appliedFilters.bedrooms.length > 0) {
            const unitBedrooms = this.getUnitBedrooms(unit);
            if (!this.appliedFilters.bedrooms.includes(unitBedrooms)) {
                return false;
            }
        }

        // Filtro de baños
        if (this.appliedFilters.bathrooms.length > 0) {
            const unitBathrooms = this.getUnitBathrooms(unit);
            if (!this.appliedFilters.bathrooms.includes(unitBathrooms)) {
                return false;
            }
        }

        // Filtro de precio mínimo
        if (this.appliedFilters.min_price !== null) {
            const unitPrice = this.getUnitPrice(unit);
            if (unitPrice < this.appliedFilters.min_price) {
                return false;
            }
        }

        // Filtro de precio máximo
        if (this.appliedFilters.max_price !== null) {
            const unitPrice = this.getUnitPrice(unit);
            if (unitPrice > this.appliedFilters.max_price) {
                return false;
            }
        }

        return true;
    },

    /**
     * Obtener el número de dormitorios de una unidad
     */
    getUnitBedrooms(unit) {
        // Soporte para estructura API
        if (unit.typology && unit.typology.bedrooms !== undefined) {
            return unit.typology.bedrooms;
        }

        // El tipo de unidad indica los dormitorios
        const tipo = unit.tipo?.toLowerCase() || '';
        if (tipo.includes('estudio')) return 0;
        if (tipo.includes('1 dormitorio')) return 1;
        if (tipo.includes('2 dormitorio')) return 2;
        if (tipo.includes('3 dormitorio')) return 3;
        if (tipo.includes('4 dormitorio') || tipo.includes('4+') || tipo.includes('4 o más')) return 4;

        // Intentar extraer número del tipo
        const match = tipo.match(/(\d+)/);
        return match ? parseInt(match[1]) : 0;
    },

    /**
     * Obtener el número de baños de una unidad
     */
    getUnitBathrooms(unit) {
        // Soporte para estructura API
        if (unit.typology && unit.typology.bathrooms !== undefined) {
            return unit.typology.bathrooms;
        }

        // Buscar en planos o en la unidad directamente
        return unit.planos?.[0]?.bathrooms || unit.bathrooms || 1;
    },

    /**
     * Obtener el precio de una unidad
     */
    getUnitPrice(unit) {
        // Soporte para estructura API donde price es un objeto
        if (unit.price && typeof unit.price === 'object' && unit.price.monto_depto) {
            return unit.price.monto_depto;
        }
        return unit.price?.monto_depto || unit.price || 0;
    },

    /**
     * Obtener texto descriptivo de los filtros aplicados
     */
    getFiltersText() {
        const parts = [];

        if (this.appliedFilters.bedrooms.length > 0) {
            const bedroomText = this.appliedFilters.bedrooms.sort((a,b) => a - b).join(', ');
            parts.push(`${bedroomText} dormitorios`);
        }

        if (this.appliedFilters.bathrooms.length > 0) {
            const bathroomText = this.appliedFilters.bathrooms.sort((a,b) => a - b).join(', ');
            parts.push(`${bathroomText} baños`);
        }

        if (this.appliedFilters.min_price || this.appliedFilters.max_price) {
            let priceText = 'Precio: ';
            if (this.appliedFilters.min_price && this.appliedFilters.max_price) {
                priceText += `${this.formatPrice(this.appliedFilters.min_price)} - ${this.formatPrice(this.appliedFilters.max_price)}`;
            } else if (this.appliedFilters.min_price) {
                priceText += `desde ${this.formatPrice(this.appliedFilters.min_price)}`;
            } else {
                priceText += `hasta ${this.formatPrice(this.appliedFilters.max_price)}`;
            }
            parts.push(priceText);
        }

        return parts.join(' • ');
    },

    async notifyMe(){

        if (!this.email) {
            this.errorMessage = 'El correo es obligatorio';
            return;
        }

        this.loading_notify = true;
        this.errorMessage = '';

        try {  
            const url = this.scheduleSubscriptionUrl;
            const payload = {
                email: this.email,
                property_id: this.selectedUnit.id
            }

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();
 
            if (!response.ok) {
               throw new Error(data.message || 'Error al procesar la solicitud');
            } 
            
            this.notified = true; 
            this.triggerToast('Te avisaremos cuando haya disponibilidad', 'success'); 
           

        }catch(e){
            this.triggerToast('No pudimos registrar tu correo. Inténtalo nuevamente.', 'error');
        }finally{ 
            //Reiniciamos  
            this.loading_notify = false;  
            this.email = '';
            this.errorMessage = '';  
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.closeDrawer();
        }
    },

    isEmailValid(fieldName) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; 
        const value = (this[fieldName] || '').trim();
        return emailRegex.test(value);
    }, 

    validateField(fieldName, errorVarName = 'errorMessage') { 
        const value = fieldName.split('.').reduce((obj, key) => obj?.[key], this)?.toString().trim() || '';
     
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        let message = '';

        if(fieldName.includes('phone')){
            const phoneRegex = /^[0-9]+$/;
            if (value.length === 0) {
                message = 'El campo es obligatorio.';
            } else if (!phoneRegex.test(value)) {
                message = 'El teléfono solo puede contener números.';
            }
            else if(value.length < 7) {
                message = 'El número de teléfono debe tener al menos 7 dígitos.';
            } else if(value.length > 15) {
                message = 'El número de teléfono debe tener como máximo 15 dígitos.';
            }
            this.setErrorMessage(errorVarName, message);
            return;
        }

        if (fieldName.includes('reason') && this.hasBroker) {
            this.setErrorMessage(errorVarName, '');
            return;
        }

        if (value.length === 0) {
            message = 'El campo es obligatorio.';
        } else if (fieldName.toLowerCase().includes('email')) {
            message = emailRegex.test(value) ? '' : 'Por favor, ingresa un correo válido.';
        }else if(fieldName.toLowerCase().includes('terms')){
            message = value === 'true' ? '' : 'Debes aceptar los términos y condiciones.';
        } else {
            message = '';
        }

        
        this.setErrorMessage(errorVarName, message);
    },

    setErrorMessage(errorVarName, message) {
        const parts = errorVarName.split('.');
        let target = this;
        for (let i = 0; i < parts.length - 1; i++) {
            target = target[parts[i]];
        }
        target[parts[parts.length - 1]] = message;
    },

    triggerToast(message, type) {
        this.toast.message = message;
        this.toast.type = type;
        this.toast.show = true;

        setTimeout(() => {
            this.toast.show = false;
        }, 5000);
    },

    showDrawerAvailable(model){  
        this.modelNoAvailable = {
            bedrooms:model.info.bedrooms,
            table_tipologia_id:model.data.plano_table_tipologias_id,
        };
        this.openDrawerAvailable = true;
    },

    closeModelDrawer() {
        this.openDrawerAvailable = false;
        this.email_model_no_available = '';
        this.errorMessageNoAvailable = '';
    },

    async notifyMeModelNoAvailable() {

        if (!this.email_model_no_available) {
            this.errorMessage = 'El correo es obligatorio';
            return;
        }

        this.loading_notify = true;
        this.errorMessage = '';

        try {

            const url = this.subscriptionUrl;

            const payload = {
                email: this.email_model_no_available,
                property_group_id: this.building.id,
                table_tipologia_id: [this.modelNoAvailable.table_tipologia_id]
            }

            const response = await fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if(response.ok){
                this.triggerToast('¡Te avisaremos apenas haya disponibilidad!', 'success'); 
            }else{
                throw new Error(data.message || 'No se pudo procesar la solicitud');
            }

        } catch (error) {
            this.triggerToast('No pudimos registrar tu correo. Inténtalo nuevamente.', 'error');
        }finally {
            this.email_model_no_available = ''; 
            this.openDrawerAvailable = false;
        }
    },

    toCoordinateVisitFromUnit() { 
        const unitId = this.selectedUnit.id;
        const typologySlug = this.slug(this.selectedUnit.tipo) || this.activeTab;
        
        const url = `${globalThis.location.origin}/coordinar-visita/${unitId}/${this.building.id}/${typologySlug}?from=1`;

        if(globalThis.assetplanAnalytics){
            globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:start_button_click', {
                building_type: this.building.multifamily ? 'multifamily' : 'retail',
                property_state: this.selectedUnit.is_visitable ? 'available' : 'not_available',
                from: 'unit',
                experiment: this.calendarExperimentVariant === 'horario-visible' ? 'ABC_SV_horario-visible' : 'ABC_SV_control',
            })
        }
   
        globalThis.location.href = url;
    },

    toCoordinateVisitFromBuilding() {
        let unit = this.getUnitMoreCheap();

        if (unit?.id) {
            const url = `${globalThis.location.origin}/coordinar-visita/${unit.id}/${this.building.id}/${this.activeTab}?from=4`;

            if(globalThis.assetplanAnalytics){
                globalThis.assetplanAnalytics.for('sitio_web').track('visit_scheduling:start_button_click', {
                    building_type: this.building.multifamily ? 'multifamily' : 'retail',
                    property_state: unit.is_visitable ? 'available' : 'not_available',
                    from: 'landing',
                    experiment: this.calendarExperimentVariant === 'horario-visible' ? 'ABC_SV_horario-visible' : 'ABC_SV_control',
                })
            }

            globalThis.location.href = url;
        } else {
           this.showDrawerAvailable(this.processedModels[0]);
        }
    },

    getUnitMoreCheap(){
        let unit_select = null;
        let minPrice = null;

        const models = this.processedModels;

        models.forEach(model => {
            if (model.info.availability > 0) {
                (model.data.unidades || []).forEach(unit => {
                    if (unit.is_available && [8].includes(unit.estado_vacios)) {
                        const price = this.getUnitPrice(unit);
                         
                        if (price > 0 && (minPrice === null || price < minPrice)) {
                            minPrice = price;
                            unit_select = unit;
                        }
                    }
                });
            }
        });
        
        return unit_select;
    },

    get hasAvailabilityInTab() {
        return this.processedModels.some(model => model.info.availabilityForCoordinateVisit > 0);
    },

    get hasAvailabilityPrice() {
        return this.processedModels.some(model => model.info.availability > 0);
    },

    /**
     * Indica si el edificio puede ofrecer una acción útil en ALGUNA tipología.
     * Commercial price remains one signal, but a loaded or selected visitable unit
     * must keep the Agenda path available even when commercial price is zero.
     */
    get hasAvailabilityInBuilding() {
        return this.tabs.some(tab => tab.min_price > 0);
    },

    get hasAgendaAvailabilityInBuilding() {
        const loadedVisitableUnit = Object.values(this.allGroupedUnits ?? {})
            .flatMap(models => models ?? [])
            .some(model => (model.unidades ?? []).some(unit => unit.is_visitable === true));

        return this.tabs.some(tab => tab.min_price > 0 || tab.has_visitable_units)
            || loadedVisitableUnit
            || this.canScheduleVisit;
    },

    /**
     * Envía action_start con payload homologado para todos los CTAs (contact_me, whatsapp).
     *
     * @param {'contact_me'|'whatsapp'} actionType
     * @param {'landing'|'unit'} from
     * @param {object|null} unit Unidad usada para resolver property_state.
     */
    trackActionStart(actionType, from, unit = this.selectedUnit) {
        if (!globalThis.assetplanAnalytics) {
            return;
        }

        globalThis.assetplanAnalytics.for('sitio_web').track('action_start', {
            action_type: actionType,
            from: from,
            building_type: this.building?.multifamily ? 'multifamily' : 'retail',
            property_state: unit?.is_visitable ? 'available' : 'not_available',
            ab_boton_qqmc: this.ctaBotonQqmcVariant,
            experiment: this.calendarExperimentVariant === 'horario-visible' ? 'ABC_SV_horario-visible' : 'ABC_SV_control',
        });
    },

    startWhatsapp(unit=null) {
        this.trackActionStart('whatsapp', unit ? 'unit' : 'landing', unit ?? this.selectedUnit);

        const num = this.epcWhatsappFromTwo || '';
        let phoneNumber = num
            .replace('+', '').replace('-', '').replace(' ', '')
            .replace(':', '').replace('whatsapp', '');

        let unit_selected = unit;
        let refUrl = `${globalThis.location.origin}${globalThis.location.pathname}`;

        let code = this.activeTab === 'estudio' ? 'ESTUDIO' : this.activeTab.split('-')[0].toUpperCase() + 'D';
        let mensaje = `¡Hola, me interesa una unidad del edificio ${this.building.name} [COD: ${this.building.id}-${code}]`;

        if(unit_selected){
            refUrl += `?unit_id=${unit_selected?.id}`;
            mensaje = `¡Hola!, tengo algunas preguntas sobre ${this.building.name}, ${refUrl}`;
        }

        whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(mensaje)}`;
        
        globalThis.location.href = whatsappUrl;
    },

    async toContactMe(){
        this.loading_form_contactme = true;
        this.showContactMeModal = true;
        this.trackActionStart('contact_me', 'landing');

        await this.fetchContactmeController();
    },

    async fetchContactmeController(){
        try {
            let url = `${globalThis.location.origin}/arriendo/departamento/contactme/${this.building.id}/${this.refer_code || ''}`;
            const response = await fetch(url);

            if(response.ok){
                const data = await response.json(); 
                this.hasBroker = data.hasbroker; 
            }else{
                throw new Error(data.message || 'No se pudo procesar la solicitud');
            } 
        
        } catch (error) {
            this.triggerToast(error.message, 'error'); 
        }finally{
            this.loading_form_contactme = false;
        }
    },

    closeContactMeModal(){
        this.showContactMeModal = false; 
        this.sendingContactForm = false;
        this.formDataContactme = createContactmeForm(this.formDataContactme);
        this.errors = {
            name: '',
            last_name: '',
            rut: '',
            email: '',
            phone: '',
            terms: '',
            reason: ''
        };
    },

    async submitContactForm(){
        this.sendingContactForm = true
        let unit = this.getUnitMoreCheap();

        try { 
            let url = `${globalThis.location.origin}/arriendo/departamento/contactme`;

            this.formDataContactme.unit_id = unit.id;
            const payload =  this.formDataContactme;
            
            const response = await fetch(url,{
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    'Accept': 'application/json', 
                },
                body: JSON.stringify(payload)
            }); 
            
            const data = await response.json();

            if(response.ok){
                if(globalThis.assetplanAnalytics){
                    globalThis.assetplanAnalytics.for('sitio_web').track('contact_form_submit')
                }

                if(data.data_layer_event){
                    globalThis.dispatchEvent(new CustomEvent('sendDataLayerCustomEvent', {
                        detail: {
                            name: data.data_layer_event.name,
                            payload: {
                                email: this.formDataContactme.email,
                                telefono: this.formDataContactme.phone,
                                comentario: this.formDataContactme.reason,
                                edificio: this.building['name'],
                                dormitorios: unit?.typology?.bedrooms > 1 ? `${unit.typology.bedrooms} dormitorios` :  `${unit.typology.bedrooms} dormitorio`,
                                comuna: this.building['commune'],
                                tipologia: unit?.typology?.id,
                                price: unit.price.monto_depto
                            }
                        }
                    }));
                }

                if (this.openDrawerUnits) {
                    this.resetForm();
                    await this.fetchSimilarBuildings();
                    this.goTo('schedule_success');
                } else {
                    this.triggerToast('Listo. Te contactaremos dentro de 48hrs.', 'success');
                    this.showContactMeModal = false;
                    this.resetForm();
                }
            }else{
                throw new Error(data.message || 'No se pudo procesar la solicitud');
            }  

        } catch (error) {
            this.triggerToast(error.message, 'error'); 
        }finally{
            this.sendingContactForm = false;
        } 
    },

    resetForm(){
        this.formDataContactme = createContactmeForm(this.formDataContactme);

        this.errors = {
            name: '',
            last_name: '',
            rut: '',
            email: '',
            phone: '',
            terms: '',
            reason: ''
        };

        // Limpiar estado del calendario interno al cerrar el drawer.
        // Esto evita que una selección anterior contamine un intento nuevo.
        this.scheduleVisitCalendar.resetTimeSlots();
        this.scheduleUrl = null;
        this.scheduleUrlV1 = null;
        this.leadId = null;
    },

    get canSubmit() { 
        const hasErrors = this.errors.name || this.errors.last_name || this.errors.email || this.errors.phone || this.errors.terms || (this.errors.reason && !this.toBroker); 
        
        const isFormEmpty = !this.formDataContactme.name || !this.formDataContactme.email || !this.formDataContactme.phone || !this.formDataContactme.terms || (!this.formDataContactme.reason && this.toBroker);

        return !hasErrors && !isFormEmpty;
    }
    
    };
};
